// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file cortado/v1/cortado.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import { CortadoService } from "./cortado_pb";

/**
 * Ping checks if the service is alive
 *
 * @generated from rpc cortado.v1.CortadoService.Ping
 */
export const ping = CortadoService.method.ping;

/**
 * GetMe retrieves the current authenticated user's data
 *
 * @generated from rpc cortado.v1.CortadoService.GetMe
 */
export const getMe = CortadoService.method.getMe;

/**
 * UpdateMe updates the current authenticated user's profile
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateMe
 */
export const updateMe = CortadoService.method.updateMe;

/**
 * ListMyOrganizations retrieves the organizations for the current authenticated user
 *
 * @generated from rpc cortado.v1.CortadoService.ListMyOrganizations
 */
export const listMyOrganizations = CortadoService.method.listMyOrganizations;

/**
 * ListMySupportSessions returns the caller's active superadmin support sessions
 *
 * @generated from rpc cortado.v1.CortadoService.ListMySupportSessions
 */
export const listMySupportSessions = CortadoService.method.listMySupportSessions;

/**
 * GetOrganization retrieves an organization by ID
 *
 * @generated from rpc cortado.v1.CortadoService.GetOrganization
 */
export const getOrganization = CortadoService.method.getOrganization;

/**
 * UpdateOrganization updates an organization
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateOrganization
 */
export const updateOrganization = CortadoService.method.updateOrganization;

/**
 * UploadOrganizationLogo uploads a logo for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.UploadOrganizationLogo
 */
export const uploadOrganizationLogo = CortadoService.method.uploadOrganizationLogo;

/**
 * ListOrganizationUsers lists all users in an organization
 *
 * @generated from rpc cortado.v1.CortadoService.ListOrganizationUsers
 */
export const listOrganizationUsers = CortadoService.method.listOrganizationUsers;

/**
 * AddUserToOrganization adds a user to an organization
 *
 * @generated from rpc cortado.v1.CortadoService.AddUserToOrganization
 */
export const addUserToOrganization = CortadoService.method.addUserToOrganization;

/**
 * UpdateOrganizationUser updates a user in an organization
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateOrganizationUser
 */
export const updateOrganizationUser = CortadoService.method.updateOrganizationUser;

/**
 * RemoveUserFromOrganization removes a user from an organization
 *
 * @generated from rpc cortado.v1.CortadoService.RemoveUserFromOrganization
 */
export const removeUserFromOrganization = CortadoService.method.removeUserFromOrganization;

/**
 * CreateOrganization creates a new organization and adds the current user as admin
 *
 * @generated from rpc cortado.v1.CortadoService.CreateOrganization
 */
export const createOrganization = CortadoService.method.createOrganization;

/**
 * GetOrganizationOnboarding retrieves the onboarding status for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.GetOrganizationOnboarding
 */
export const getOrganizationOnboarding = CortadoService.method.getOrganizationOnboarding;

/**
 * UpdateOnboardingStep marks an onboarding step as complete or incomplete
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateOnboardingStep
 */
export const updateOnboardingStep = CortadoService.method.updateOnboardingStep;

/**
 * SkipOnboardingStep marks an onboarding step as skipped
 *
 * @generated from rpc cortado.v1.CortadoService.SkipOnboardingStep
 */
export const skipOnboardingStep = CortadoService.method.skipOnboardingStep;

/**
 * CheckSlugAvailability checks if a slug is available for use
 *
 * @generated from rpc cortado.v1.CortadoService.CheckSlugAvailability
 */
export const checkSlugAvailability = CortadoService.method.checkSlugAvailability;

/**
 * ListAgreements lists all agreements for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.ListAgreements
 */
export const listAgreements = CortadoService.method.listAgreements;

/**
 * GetAgreement retrieves an agreement by ID
 *
 * @generated from rpc cortado.v1.CortadoService.GetAgreement
 */
export const getAgreement = CortadoService.method.getAgreement;

/**
 * CreateAgreement creates a new agreement
 *
 * @generated from rpc cortado.v1.CortadoService.CreateAgreement
 */
export const createAgreement = CortadoService.method.createAgreement;

/**
 * UpdateAgreement updates an agreement
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateAgreement
 */
export const updateAgreement = CortadoService.method.updateAgreement;

/**
 * DeleteAgreement deletes an agreement
 *
 * @generated from rpc cortado.v1.CortadoService.DeleteAgreement
 */
export const deleteAgreement = CortadoService.method.deleteAgreement;

/**
 * CreateAgreementClause creates a new clause within an agreement
 *
 * @generated from rpc cortado.v1.CortadoService.CreateAgreementClause
 */
export const createAgreementClause = CortadoService.method.createAgreementClause;

/**
 * UpdateAgreementClause updates a clause
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateAgreementClause
 */
export const updateAgreementClause = CortadoService.method.updateAgreementClause;

/**
 * DeleteAgreementClause deletes a clause
 *
 * @generated from rpc cortado.v1.CortadoService.DeleteAgreementClause
 */
export const deleteAgreementClause = CortadoService.method.deleteAgreementClause;

/**
 * ReorderAgreementClauses reorders clauses within an agreement
 *
 * @generated from rpc cortado.v1.CortadoService.ReorderAgreementClauses
 */
export const reorderAgreementClauses = CortadoService.method.reorderAgreementClauses;

/**
 * GenerateAgreementClauses drafts client-portal agreement clauses with AI.
 * Pure generation - nothing is persisted.
 *
 * @generated from rpc cortado.v1.CortadoService.GenerateAgreementClauses
 */
export const generateAgreementClauses = CortadoService.method.generateAgreementClauses;

/**
 * ListUnavailableDates lists unavailable dates for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.ListUnavailableDates
 */
export const listUnavailableDates = CortadoService.method.listUnavailableDates;

/**
 * CreateUnavailableDate marks a date as unavailable for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.CreateUnavailableDate
 */
export const createUnavailableDate = CortadoService.method.createUnavailableDate;

/**
 * UpdateUnavailableDate updates an unavailable date entry
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateUnavailableDate
 */
export const updateUnavailableDate = CortadoService.method.updateUnavailableDate;

/**
 * DeleteUnavailableDate removes an unavailable date entry
 *
 * @generated from rpc cortado.v1.CortadoService.DeleteUnavailableDate
 */
export const deleteUnavailableDate = CortadoService.method.deleteUnavailableDate;

/**
 * ListOrganizationRoles lists all roles for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.ListOrganizationRoles
 */
export const listOrganizationRoles = CortadoService.method.listOrganizationRoles;

/**
 * GetOrganizationRole retrieves a single role by ID
 *
 * @generated from rpc cortado.v1.CortadoService.GetOrganizationRole
 */
export const getOrganizationRole = CortadoService.method.getOrganizationRole;

/**
 * CreateOrganizationRole creates a new role for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.CreateOrganizationRole
 */
export const createOrganizationRole = CortadoService.method.createOrganizationRole;

/**
 * UpdateOrganizationRole updates an existing role
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateOrganizationRole
 */
export const updateOrganizationRole = CortadoService.method.updateOrganizationRole;

/**
 * DeleteOrganizationRole deletes a role (cannot delete Admin role)
 *
 * @generated from rpc cortado.v1.CortadoService.DeleteOrganizationRole
 */
export const deleteOrganizationRole = CortadoService.method.deleteOrganizationRole;

/**
 * ListPermissions lists all available permissions
 *
 * @generated from rpc cortado.v1.CortadoService.ListPermissions
 */
export const listPermissions = CortadoService.method.listPermissions;

/**
 * ListOrganizationEventTypes lists all event types for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.ListOrganizationEventTypes
 */
export const listOrganizationEventTypes = CortadoService.method.listOrganizationEventTypes;

/**
 * CreateOrganizationEventType creates a new event type for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.CreateOrganizationEventType
 */
export const createOrganizationEventType = CortadoService.method.createOrganizationEventType;

/**
 * UpdateOrganizationEventType updates an existing event type
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateOrganizationEventType
 */
export const updateOrganizationEventType = CortadoService.method.updateOrganizationEventType;

/**
 * ArchiveOrganizationEventType archives an event type (soft delete)
 *
 * @generated from rpc cortado.v1.CortadoService.ArchiveOrganizationEventType
 */
export const archiveOrganizationEventType = CortadoService.method.archiveOrganizationEventType;

/**
 * ReorderOrganizationEventTypes reorders the display order of an organization's event types
 *
 * @generated from rpc cortado.v1.CortadoService.ReorderOrganizationEventTypes
 */
export const reorderOrganizationEventTypes = CortadoService.method.reorderOrganizationEventTypes;

/**
 * GetSystemSettings retrieves all system enum settings
 *
 * @generated from rpc cortado.v1.CortadoService.GetSystemSettings
 */
export const getSystemSettings = CortadoService.method.getSystemSettings;

/**
 * GetDashboardTasks retrieves tasks for the dashboard with enriched data
 *
 * @generated from rpc cortado.v1.CortadoService.GetDashboardTasks
 */
export const getDashboardTasks = CortadoService.method.getDashboardTasks;

/**
 * GetDashboardUpcomingEvents retrieves upcoming events for the dashboard with enriched data
 *
 * @generated from rpc cortado.v1.CortadoService.GetDashboardUpcomingEvents
 */
export const getDashboardUpcomingEvents = CortadoService.method.getDashboardUpcomingEvents;

/**
 * GetDashboardBookings retrieves bookings for the dashboard with enriched data
 *
 * @generated from rpc cortado.v1.CortadoService.GetDashboardBookings
 */
export const getDashboardBookings = CortadoService.method.getDashboardBookings;

/**
 * GetDashboardOverduePaymentSchedules retrieves overdue payment schedules for the dashboard
 *
 * @generated from rpc cortado.v1.CortadoService.GetDashboardOverduePaymentSchedules
 */
export const getDashboardOverduePaymentSchedules = CortadoService.method.getDashboardOverduePaymentSchedules;

/**
 * GetDashboardUpcomingPaymentSchedules retrieves upcoming payment schedules for the dashboard
 *
 * @generated from rpc cortado.v1.CortadoService.GetDashboardUpcomingPaymentSchedules
 */
export const getDashboardUpcomingPaymentSchedules = CortadoService.method.getDashboardUpcomingPaymentSchedules;

/**
 * GetDashboardSummary aggregates the events/tasks/leads/payment-schedule widgets on the
 * dashboard home page into a single round trip. All windows/filters are client-supplied
 * (mirroring the individual ListEvents/ListTasks/ListInquiries/GetDashboardOverduePaymentSchedules/
 * GetDashboardUpcomingPaymentSchedules requests they replace) so the server never has to guess
 * the caller's local timezone.
 *
 * @generated from rpc cortado.v1.CortadoService.GetDashboardSummary
 */
export const getDashboardSummary = CortadoService.method.getDashboardSummary;

/**
 * ListActivities retrieves the activity feed for the dashboard
 *
 * @generated from rpc cortado.v1.CortadoService.ListActivities
 */
export const listActivities = CortadoService.method.listActivities;

/**
 * @generated from rpc cortado.v1.CortadoService.GetJob
 */
export const getJob = CortadoService.method.getJob;

/**
 * @generated from rpc cortado.v1.CortadoService.ListJobs
 */
export const listJobs = CortadoService.method.listJobs;

/**
 * @generated from rpc cortado.v1.CortadoService.GetPipelineSummary
 */
export const getPipelineSummary = CortadoService.method.getPipelineSummary;

/**
 * @generated from rpc cortado.v1.CortadoService.ListJobActivity
 */
export const listJobActivity = CortadoService.method.listJobActivity;

/**
 * ListJobEvents returns exactly the events JobLite.event_count counts.
 *
 * @generated from rpc cortado.v1.CortadoService.ListJobEvents
 */
export const listJobEvents = CortadoService.method.listJobEvents;

/**
 * ListUnreadAnnouncements retrieves broadcast announcements the current user has not read.
 *
 * @generated from rpc cortado.v1.CortadoService.ListUnreadAnnouncements
 */
export const listUnreadAnnouncements = CortadoService.method.listUnreadAnnouncements;

/**
 * MarkAnnouncementRead marks one broadcast announcement read for the current user.
 *
 * @generated from rpc cortado.v1.CortadoService.MarkAnnouncementRead
 */
export const markAnnouncementRead = CortadoService.method.markAnnouncementRead;

/**
 * ListContacts lists all contacts for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.ListContacts
 */
export const listContacts = CortadoService.method.listContacts;

/**
 * CreateContact creates a new contact
 *
 * @generated from rpc cortado.v1.CortadoService.CreateContact
 */
export const createContact = CortadoService.method.createContact;

/**
 * GetContact retrieves a contact by ID
 *
 * @generated from rpc cortado.v1.CortadoService.GetContact
 */
export const getContact = CortadoService.method.getContact;

/**
 * UpdateContact updates a contact
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateContact
 */
export const updateContact = CortadoService.method.updateContact;

/**
 * DeleteContact deletes a contact
 *
 * @generated from rpc cortado.v1.CortadoService.DeleteContact
 */
export const deleteContact = CortadoService.method.deleteContact;

/**
 * ArchiveContact hides a contact from active lists while preserving history
 *
 * @generated from rpc cortado.v1.CortadoService.ArchiveContact
 */
export const archiveContact = CortadoService.method.archiveContact;

/**
 * UnarchiveContact restores an archived contact
 *
 * @generated from rpc cortado.v1.CortadoService.UnarchiveContact
 */
export const unarchiveContact = CortadoService.method.unarchiveContact;

/**
 * GetContactByEmail retrieves a contact by email within an organization.
 * Matches any of a contact's addresses, not only the primary one.
 *
 * @generated from rpc cortado.v1.CortadoService.GetContactByEmail
 */
export const getContactByEmail = CortadoService.method.getContactByEmail;

/**
 * AddContactEmail adds another address to a contact. AlreadyExists when the
 * address already belongs to a contact in the organization.
 *
 * @generated from rpc cortado.v1.CortadoService.AddContactEmail
 */
export const addContactEmail = CortadoService.method.addContactEmail;

/**
 * RemoveContactEmail removes one of a contact's addresses. Removing the
 * primary promotes the oldest remaining address.
 *
 * @generated from rpc cortado.v1.CortadoService.RemoveContactEmail
 */
export const removeContactEmail = CortadoService.method.removeContactEmail;

/**
 * SetPrimaryContactEmail makes one of a contact's addresses its primary
 * (Contact.email).
 *
 * @generated from rpc cortado.v1.CortadoService.SetPrimaryContactEmail
 */
export const setPrimaryContactEmail = CortadoService.method.setPrimaryContactEmail;

/**
 * ListCompanies lists all companies for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.ListCompanies
 */
export const listCompanies = CortadoService.method.listCompanies;

/**
 * CreateCompany creates a new company
 *
 * @generated from rpc cortado.v1.CortadoService.CreateCompany
 */
export const createCompany = CortadoService.method.createCompany;

/**
 * GetCompany retrieves a company by ID
 *
 * @generated from rpc cortado.v1.CortadoService.GetCompany
 */
export const getCompany = CortadoService.method.getCompany;

/**
 * UpdateCompany updates a company
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateCompany
 */
export const updateCompany = CortadoService.method.updateCompany;

/**
 * DeleteCompany deletes a company
 *
 * @generated from rpc cortado.v1.CortadoService.DeleteCompany
 */
export const deleteCompany = CortadoService.method.deleteCompany;

/**
 * ArchiveCompany hides a company from active lists while preserving history
 *
 * @generated from rpc cortado.v1.CortadoService.ArchiveCompany
 */
export const archiveCompany = CortadoService.method.archiveCompany;

/**
 * UnarchiveCompany restores an archived company
 *
 * @generated from rpc cortado.v1.CortadoService.UnarchiveCompany
 */
export const unarchiveCompany = CortadoService.method.unarchiveCompany;

/**
 * AddContactToCompany adds a contact to a company with optional title
 *
 * @generated from rpc cortado.v1.CortadoService.AddContactToCompany
 */
export const addContactToCompany = CortadoService.method.addContactToCompany;

/**
 * RemoveContactFromCompany removes a contact from a company
 *
 * @generated from rpc cortado.v1.CortadoService.RemoveContactFromCompany
 */
export const removeContactFromCompany = CortadoService.method.removeContactFromCompany;

/**
 * CreateInquiry creates a new inquiry
 *
 * @generated from rpc cortado.v1.CortadoService.CreateInquiry
 */
export const createInquiry = CortadoService.method.createInquiry;

/**
 * GetInquiry retrieves an inquiry by ID
 *
 * @generated from rpc cortado.v1.CortadoService.GetInquiry
 */
export const getInquiry = CortadoService.method.getInquiry;

/**
 * GetInquiryOverlaps retrieves leads and events that overlap with an inquiry's date/time
 *
 * @generated from rpc cortado.v1.CortadoService.GetInquiryOverlaps
 */
export const getInquiryOverlaps = CortadoService.method.getInquiryOverlaps;

/**
 * CreateInquiryEvent creates a new event for an inquiry
 *
 * @generated from rpc cortado.v1.CortadoService.CreateInquiryEvent
 */
export const createInquiryEvent = CortadoService.method.createInquiryEvent;

/**
 * UpdateInquiryEvent updates an inquiry event
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateInquiryEvent
 */
export const updateInquiryEvent = CortadoService.method.updateInquiryEvent;

/**
 * DeleteInquiryEvent deletes an inquiry event
 *
 * @generated from rpc cortado.v1.CortadoService.DeleteInquiryEvent
 */
export const deleteInquiryEvent = CortadoService.method.deleteInquiryEvent;

/**
 * ListInquiryEvents lists all events for an inquiry
 *
 * @generated from rpc cortado.v1.CortadoService.ListInquiryEvents
 */
export const listInquiryEvents = CortadoService.method.listInquiryEvents;

/**
 * UpdateInquiry updates an inquiry
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateInquiry
 */
export const updateInquiry = CortadoService.method.updateInquiry;

/**
 * ListOrganizationInquiries lists all inquiries for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.ListOrganizationInquiries
 */
export const listOrganizationInquiries = CortadoService.method.listOrganizationInquiries;

/**
 * ListInquiries lists inquiries with comprehensive filtering support
 *
 * @generated from rpc cortado.v1.CortadoService.ListInquiries
 */
export const listInquiries = CortadoService.method.listInquiries;

/**
 * GeneratePortalLink generates a shareable portal link with JWT token for an inquiry
 *
 * @generated from rpc cortado.v1.CortadoService.GeneratePortalLink
 */
export const generatePortalLink = CortadoService.method.generatePortalLink;

/**
 * GenerateInvoicePortalLink generates a shareable portal link with JWT token for an invoice
 * Supports both inquiry-scoped tokens (if booking has inquiry) and booking-scoped tokens
 *
 * @generated from rpc cortado.v1.CortadoService.GenerateInvoicePortalLink
 */
export const generateInvoicePortalLink = CortadoService.method.generateInvoicePortalLink;

/**
 * GetPublicInquiry retrieves public inquiry data for customer-facing portal
 *
 * @generated from rpc cortado.v1.CortadoService.GetPublicInquiry
 */
export const getPublicInquiry = CortadoService.method.getPublicInquiry;

/**
 * GetPublicQuote retrieves full quote details for customer-facing portal
 *
 * @generated from rpc cortado.v1.CortadoService.GetPublicQuote
 */
export const getPublicQuote = CortadoService.method.getPublicQuote;

/**
 * PreviewPublicQuote recomputes a quote's totals with the customer's requested
 * add-on selections applied. Fully server-side; never persisted.
 *
 * @generated from rpc cortado.v1.CortadoService.PreviewPublicQuote
 */
export const previewPublicQuote = CortadoService.method.previewPublicQuote;

/**
 * GeneratePublicQuotePdf returns a cached or newly rendered quote PDF.
 *
 * @generated from rpc cortado.v1.CortadoService.GeneratePublicQuotePdf
 */
export const generatePublicQuotePdf = CortadoService.method.generatePublicQuotePdf;

/**
 * AcceptPublicQuote accepts a quote and creates booking + invoice
 *
 * @generated from rpc cortado.v1.CortadoService.AcceptPublicQuote
 */
export const acceptPublicQuote = CortadoService.method.acceptPublicQuote;

/**
 * RejectPublicQuote declines a quote on behalf of the customer.
 * Idempotent: rejecting an already-rejected quote returns success.
 * Portal tokens are optional and used only for attribution (matches AcceptPublicQuote).
 *
 * @generated from rpc cortado.v1.CortadoService.RejectPublicQuote
 */
export const rejectPublicQuote = CortadoService.method.rejectPublicQuote;

/**
 * MarkPublicQuoteViewed marks a quote as viewed by the customer
 *
 * @generated from rpc cortado.v1.CortadoService.MarkPublicQuoteViewed
 */
export const markPublicQuoteViewed = CortadoService.method.markPublicQuoteViewed;

/**
 * GetPublicBooking retrieves public booking data for customer-facing portal
 *
 * @generated from rpc cortado.v1.CortadoService.GetPublicBooking
 */
export const getPublicBooking = CortadoService.method.getPublicBooking;

/**
 * SubmitPublicBookingQuestionnaire writes customer answers onto the booking's
 * questionnaire snapshot. Portal tokens are optional and used only for
 * attribution (matches GetPublicBooking). Does not read the event-type template.
 *
 * @generated from rpc cortado.v1.CortadoService.SubmitPublicBookingQuestionnaire
 */
export const submitPublicBookingQuestionnaire = CortadoService.method.submitPublicBookingQuestionnaire;

/**
 * UploadPublicBookingQuestionnaireFile stores one file for a file-upload
 * question as an attachment on the booking. It does not change the
 * questionnaire; submit the returned attachment ID as the item's answer.
 * Portal tokens are optional and used only for attribution.
 *
 * @generated from rpc cortado.v1.CortadoService.UploadPublicBookingQuestionnaireFile
 */
export const uploadPublicBookingQuestionnaireFile = CortadoService.method.uploadPublicBookingQuestionnaireFile;

/**
 * GetPublicInvoice retrieves public invoice data for customer-facing portal
 *
 * @generated from rpc cortado.v1.CortadoService.GetPublicInvoice
 */
export const getPublicInvoice = CortadoService.method.getPublicInvoice;

/**
 * GeneratePublicInvoicePdf returns a cached or newly rendered invoice PDF.
 *
 * @generated from rpc cortado.v1.CortadoService.GeneratePublicInvoicePdf
 */
export const generatePublicInvoicePdf = CortadoService.method.generatePublicInvoicePdf;

/**
 * GeneratePublicPaymentReceiptPdf returns a cached or newly rendered receipt PDF
 * for a payment schedule that has at least one completed payment.
 *
 * @generated from rpc cortado.v1.CortadoService.GeneratePublicPaymentReceiptPdf
 */
export const generatePublicPaymentReceiptPdf = CortadoService.method.generatePublicPaymentReceiptPdf;

/**
 * UpdatePublicInvoiceTip updates the customer tip for an invoice
 *
 * @generated from rpc cortado.v1.CortadoService.UpdatePublicInvoiceTip
 */
export const updatePublicInvoiceTip = CortadoService.method.updatePublicInvoiceTip;

/**
 * CreatePublicPaymentIntent is a dead endpoint that always returns Unimplemented.
 * Use CreatePublicCheckoutSession (Stripe Embedded Checkout) instead.
 * Kept in the proto so old clients fail loudly instead of breaking at decode time.
 *
 * @generated from rpc cortado.v1.CortadoService.CreatePublicPaymentIntent
 * @deprecated
 */
export const createPublicPaymentIntent = CortadoService.method.createPublicPaymentIntent;

/**
 * CreatePublicCheckoutSession creates a Stripe Checkout Session for a payment schedule item
 *
 * @generated from rpc cortado.v1.CortadoService.CreatePublicCheckoutSession
 */
export const createPublicCheckoutSession = CortadoService.method.createPublicCheckoutSession;

/**
 * CreatePublicResidualTipCheckoutSession creates a tip-only Stripe Checkout Session to
 * collect outstanding tip after the invoice base is fully paid (CPRO-652 H2b).
 *
 * @generated from rpc cortado.v1.CortadoService.CreatePublicResidualTipCheckoutSession
 */
export const createPublicResidualTipCheckoutSession = CortadoService.method.createPublicResidualTipCheckoutSession;

/**
 * GetPublicCheckoutSessionStatus retrieves the status of a Stripe Checkout Session
 *
 * @generated from rpc cortado.v1.CortadoService.GetPublicCheckoutSessionStatus
 */
export const getPublicCheckoutSessionStatus = CortadoService.method.getPublicCheckoutSessionStatus;

/**
 * GeneratePublicPortalLink generates a new shareable link from portal (requires token auth)
 *
 * @generated from rpc cortado.v1.CortadoService.GeneratePublicPortalLink
 */
export const generatePublicPortalLink = CortadoService.method.generatePublicPortalLink;

/**
 * SharePublicInquiryByEmail sends inquiry links via email
 *
 * @generated from rpc cortado.v1.CortadoService.SharePublicInquiryByEmail
 */
export const sharePublicInquiryByEmail = CortadoService.method.sharePublicInquiryByEmail;

/**
 * SharePublicInvoiceByEmail sends invoice links via email
 *
 * @generated from rpc cortado.v1.CortadoService.SharePublicInvoiceByEmail
 */
export const sharePublicInvoiceByEmail = CortadoService.method.sharePublicInvoiceByEmail;

/**
 * ConvertToPayInFull converts multiple payment schedules to a single "pay in full" schedule
 * Only allowed when invoice has multiple schedules and no payments have been made
 *
 * @generated from rpc cortado.v1.CortadoService.ConvertToPayInFull
 */
export const convertToPayInFull = CortadoService.method.convertToPayInFull;

/**
 * ResolvePortalLink exchanges an opaque short code for a portal token and
 * canonical resource path. Public only through the portal API mount.
 *
 * @generated from rpc cortado.v1.CortadoService.ResolvePortalLink
 */
export const resolvePortalLink = CortadoService.method.resolvePortalLink;

/**
 * GetInquiryOrgInfo returns org info for a given inquiry token — public endpoint, no auth required, works with expired tokens
 *
 * @generated from rpc cortado.v1.CortadoService.GetInquiryOrgInfo
 */
export const getInquiryOrgInfo = CortadoService.method.getInquiryOrgInfo;

/**
 * ResendPortalLink reissues the caller's portal token (preserving its JTI) and emails a fresh link to the original recipient.
 * Public endpoint — accepts expired tokens. Returns success-shaped responses for invalid tokens to avoid enumeration.
 *
 * @generated from rpc cortado.v1.CortadoService.ResendPortalLink
 */
export const resendPortalLink = CortadoService.method.resendPortalLink;

/**
 * ListEvents lists events with filtering and pagination
 *
 * @generated from rpc cortado.v1.CortadoService.ListEvents
 */
export const listEvents = CortadoService.method.listEvents;

/**
 * ListTasks lists tasks with filtering and pagination
 *
 * @generated from rpc cortado.v1.CortadoService.ListTasks
 */
export const listTasks = CortadoService.method.listTasks;

/**
 * GetBooking retrieves a booking by ID
 *
 * @generated from rpc cortado.v1.CortadoService.GetBooking
 */
export const getBooking = CortadoService.method.getBooking;

/**
 * UpdateBooking updates a booking
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateBooking
 */
export const updateBooking = CortadoService.method.updateBooking;

/**
 * UpdateBookingQuestionnaire replaces a booking's questionnaire with the
 * given items, in order. Staff author the questionnaire directly - it does
 * not depend on org/event-type templates. Answers are server-owned: the
 * caller's answer content is ignored, and any existing answer is carried
 * over only when its item survives unchanged in type (and, for choice
 * items, its answered options still exist). An empty items list clears the
 * booking's questionnaire.
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateBookingQuestionnaire
 */
export const updateBookingQuestionnaire = CortadoService.method.updateBookingQuestionnaire;

/**
 * CreateBooking creates a new booking directly (without requiring an inquiry)
 *
 * @generated from rpc cortado.v1.CortadoService.CreateBooking
 */
export const createBooking = CortadoService.method.createBooking;

/**
 * MoveInquiryToEvents creates a booking and events from an accepted inquiry
 * Used when an inquiry is manually accepted without going through quote acceptance
 *
 * @generated from rpc cortado.v1.CortadoService.MoveInquiryToEvents
 */
export const moveInquiryToEvents = CortadoService.method.moveInquiryToEvents;

/**
 * AcceptQuoteAsAdmin accepts a quote as an admin, creating a booking + events + invoice
 *
 * @generated from rpc cortado.v1.CortadoService.AcceptQuoteAsAdmin
 */
export const acceptQuoteAsAdmin = CortadoService.method.acceptQuoteAsAdmin;

/**
 * GetEvent retrieves an event by ID with full enrichment
 *
 * @generated from rpc cortado.v1.CortadoService.GetEvent
 */
export const getEvent = CortadoService.method.getEvent;

/**
 * GetEventDetail is an aggregate endpoint returning the event plus its
 * booking and (when the booking came from an inquiry) the inquiry, in one
 * round-trip, to eliminate the event-detail page request waterfall.
 *
 * @generated from rpc cortado.v1.CortadoService.GetEventDetail
 */
export const getEventDetail = CortadoService.method.getEventDetail;

/**
 * CreateEvent creates a new event within a booking
 *
 * @generated from rpc cortado.v1.CortadoService.CreateEvent
 */
export const createEvent = CortadoService.method.createEvent;

/**
 * UpdateEvent updates an event
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateEvent
 */
export const updateEvent = CortadoService.method.updateEvent;

/**
 * ArchiveEvent soft-deletes an event
 *
 * @generated from rpc cortado.v1.CortadoService.ArchiveEvent
 */
export const archiveEvent = CortadoService.method.archiveEvent;

/**
 * UnarchiveEvent restores an archived event
 *
 * @generated from rpc cortado.v1.CortadoService.UnarchiveEvent
 */
export const unarchiveEvent = CortadoService.method.unarchiveEvent;

/**
 * ArchiveInquiry soft-deletes an inquiry (lead), optionally cascading to its booking's events
 *
 * @generated from rpc cortado.v1.CortadoService.ArchiveInquiry
 */
export const archiveInquiry = CortadoService.method.archiveInquiry;

/**
 * UnarchiveInquiry restores an archived inquiry (lead)
 *
 * @generated from rpc cortado.v1.CortadoService.UnarchiveInquiry
 */
export const unarchiveInquiry = CortadoService.method.unarchiveInquiry;

/**
 * Lead referrals: send a lead to another organization by its referral code.
 * GetLeadReferralSettings returns the organization's opt-in and code.
 *
 * @generated from rpc cortado.v1.CortadoService.GetLeadReferralSettings
 */
export const getLeadReferralSettings = CortadoService.method.getLeadReferralSettings;

/**
 * UpdateLeadReferralSettings turns receiving referrals on or off.
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateLeadReferralSettings
 */
export const updateLeadReferralSettings = CortadoService.method.updateLeadReferralSettings;

/**
 * RegenerateLeadReferralCode replaces the organization's code.
 *
 * @generated from rpc cortado.v1.CortadoService.RegenerateLeadReferralCode
 */
export const regenerateLeadReferralCode = CortadoService.method.regenerateLeadReferralCode;

/**
 * LookupLeadReferralCode returns the name of the organization holding a code.
 *
 * @generated from rpc cortado.v1.CortadoService.LookupLeadReferralCode
 */
export const lookupLeadReferralCode = CortadoService.method.lookupLeadReferralCode;

/**
 * ListLeadReferralPartners lists saved codes.
 *
 * @generated from rpc cortado.v1.CortadoService.ListLeadReferralPartners
 */
export const listLeadReferralPartners = CortadoService.method.listLeadReferralPartners;

/**
 * CreateLeadReferralPartner saves a code.
 *
 * @generated from rpc cortado.v1.CortadoService.CreateLeadReferralPartner
 */
export const createLeadReferralPartner = CortadoService.method.createLeadReferralPartner;

/**
 * DeleteLeadReferralPartner removes a saved code.
 *
 * @generated from rpc cortado.v1.CortadoService.DeleteLeadReferralPartner
 */
export const deleteLeadReferralPartner = CortadoService.method.deleteLeadReferralPartner;

/**
 * SendLeadReferral refers a lead to another organization.
 *
 * @generated from rpc cortado.v1.CortadoService.SendLeadReferral
 */
export const sendLeadReferral = CortadoService.method.sendLeadReferral;

/**
 * ListLeadReferrals lists referrals the organization sent.
 *
 * @generated from rpc cortado.v1.CortadoService.ListLeadReferrals
 */
export const listLeadReferrals = CortadoService.method.listLeadReferrals;

/**
 * ListIncomingLeadReferrals lists referrals waiting on the organization.
 *
 * @generated from rpc cortado.v1.CortadoService.ListIncomingLeadReferrals
 */
export const listIncomingLeadReferrals = CortadoService.method.listIncomingLeadReferrals;

/**
 * AcceptLeadReferral copies the referred lead into the organization.
 *
 * @generated from rpc cortado.v1.CortadoService.AcceptLeadReferral
 */
export const acceptLeadReferral = CortadoService.method.acceptLeadReferral;

/**
 * RejectLeadReferral declines a referral.
 *
 * @generated from rpc cortado.v1.CortadoService.RejectLeadReferral
 */
export const rejectLeadReferral = CortadoService.method.rejectLeadReferral;

/**
 * WithdrawLeadReferral takes back a pending referral the organization sent.
 *
 * @generated from rpc cortado.v1.CortadoService.WithdrawLeadReferral
 */
export const withdrawLeadReferral = CortadoService.method.withdrawLeadReferral;

/**
 * SyncEventCalendar triggers a Google Calendar sync for an event
 *
 * @generated from rpc cortado.v1.CortadoService.SyncEventCalendar
 */
export const syncEventCalendar = CortadoService.method.syncEventCalendar;

/**
 * GetEventDriveTime calculates drive time from org address to event location
 *
 * @generated from rpc cortado.v1.CortadoService.GetEventDriveTime
 */
export const getEventDriveTime = CortadoService.method.getEventDriveTime;

/**
 * GetInquiryDriveTime calculates drive time from org address to an inquiry's location
 *
 * @generated from rpc cortado.v1.CortadoService.GetInquiryDriveTime
 */
export const getInquiryDriveTime = CortadoService.method.getInquiryDriveTime;

/**
 * ListEventAddons lists the event's add-ons: the ones the customer accepted
 * on the quote that booked it, less any removed, plus any added on the event.
 *
 * @generated from rpc cortado.v1.CortadoService.ListEventAddons
 */
export const listEventAddons = CortadoService.method.listEventAddons;

/**
 * AddEventAddon adds a catalog add-on to the event without changing the quote.
 *
 * @generated from rpc cortado.v1.CortadoService.AddEventAddon
 */
export const addEventAddon = CortadoService.method.addEventAddon;

/**
 * RemoveEventAddon takes an add-on off the event without changing the quote.
 *
 * @generated from rpc cortado.v1.CortadoService.RemoveEventAddon
 */
export const removeEventAddon = CortadoService.method.removeEventAddon;

/**
 * RestoreEventAddon puts a removed quote add-on back on the event.
 *
 * @generated from rpc cortado.v1.CortadoService.RestoreEventAddon
 */
export const restoreEventAddon = CortadoService.method.restoreEventAddon;

/**
 * PreviewEventInventory computes the event's packing list from its current
 * inputs (org inventory settings, guests, length, accepted add-ons). Nothing
 * is saved.
 *
 * @generated from rpc cortado.v1.CortadoService.PreviewEventInventory
 */
export const previewEventInventory = CortadoService.method.previewEventInventory;

/**
 * PreviewEventTimeline computes the event's run of show from its current
 * inputs (org time settings, drive time, cart count). Nothing is saved.
 *
 * @generated from rpc cortado.v1.CortadoService.PreviewEventTimeline
 */
export const previewEventTimeline = CortadoService.method.previewEventTimeline;

/**
 * GetEventPackingList returns the event's saved packing list and whether
 * its inputs changed since it was made. Generates the list on first view.
 *
 * @generated from rpc cortado.v1.CortadoService.GetEventPackingList
 */
export const getEventPackingList = CortadoService.method.getEventPackingList;

/**
 * RegenerateEventPackingList rebuilds the computed and add-on rows from the
 * event's current inputs, resetting their overrides and packed marks.
 *
 * @generated from rpc cortado.v1.CortadoService.RegenerateEventPackingList
 */
export const regenerateEventPackingList = CortadoService.method.regenerateEventPackingList;

/**
 * SetEventPackingItemPacked marks a packing row packed or unpacked.
 *
 * @generated from rpc cortado.v1.CortadoService.SetEventPackingItemPacked
 */
export const setEventPackingItemPacked = CortadoService.method.setEventPackingItemPacked;

/**
 * SetEventPackingItemQuantity overrides (or clears) a row's quantity.
 *
 * @generated from rpc cortado.v1.CortadoService.SetEventPackingItemQuantity
 */
export const setEventPackingItemQuantity = CortadoService.method.setEventPackingItemQuantity;

/**
 * AddEventPackingItem adds a manual row to the event's packing list.
 *
 * @generated from rpc cortado.v1.CortadoService.AddEventPackingItem
 */
export const addEventPackingItem = CortadoService.method.addEventPackingItem;

/**
 * DeleteEventPackingItem removes a manual row from the event's packing list.
 *
 * @generated from rpc cortado.v1.CortadoService.DeleteEventPackingItem
 */
export const deleteEventPackingItem = CortadoService.method.deleteEventPackingItem;

/**
 * GetEventTimeline returns the event's saved run-of-show timeline and what
 * changed since it was generated, generating it on first read.
 *
 * @generated from rpc cortado.v1.CortadoService.GetEventTimeline
 */
export const getEventTimeline = CortadoService.method.getEventTimeline;

/**
 * UpdateEventTimelineBlocks replaces the event's timeline blocks with an
 * edited list and marks the timeline customized.
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateEventTimelineBlocks
 */
export const updateEventTimelineBlocks = CortadoService.method.updateEventTimelineBlocks;

/**
 * RegenerateEventTimeline recalculates the event's timeline from its
 * current inputs, discarding edits.
 *
 * @generated from rpc cortado.v1.CortadoService.RegenerateEventTimeline
 */
export const regenerateEventTimeline = CortadoService.method.regenerateEventTimeline;

/**
 * ResolveLocationTimezone returns the IANA timezone for a given postal
 * address by geocoding it. Used by the timezone picker's "Use location
 * timezone" link to recover the auto-detected zone after a manual override.
 *
 * @generated from rpc cortado.v1.CortadoService.ResolveLocationTimezone
 */
export const resolveLocationTimezone = CortadoService.method.resolveLocationTimezone;

/**
 * ListUserSchedulings lists user schedulings with optional filtering
 *
 * @generated from rpc cortado.v1.CortadoService.ListUserSchedulings
 */
export const listUserSchedulings = CortadoService.method.listUserSchedulings;

/**
 * GetUserScheduling retrieves a single user scheduling by ID
 *
 * @generated from rpc cortado.v1.CortadoService.GetUserScheduling
 */
export const getUserScheduling = CortadoService.method.getUserScheduling;

/**
 * CreateUserScheduling creates a new user scheduling
 *
 * @generated from rpc cortado.v1.CortadoService.CreateUserScheduling
 */
export const createUserScheduling = CortadoService.method.createUserScheduling;

/**
 * UpdateUserScheduling updates an existing user scheduling
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateUserScheduling
 */
export const updateUserScheduling = CortadoService.method.updateUserScheduling;

/**
 * DeleteUserScheduling deletes a user scheduling
 *
 * @generated from rpc cortado.v1.CortadoService.DeleteUserScheduling
 */
export const deleteUserScheduling = CortadoService.method.deleteUserScheduling;

/**
 * ListEventStaffAvailability lists every org member with whether they can
 * work the event: unavailable when assigned to another event that overlaps
 * the on-site window, or when the window touches an org blackout date.
 *
 * @generated from rpc cortado.v1.CortadoService.ListEventStaffAvailability
 */
export const listEventStaffAvailability = CortadoService.method.listEventStaffAvailability;

/**
 * ListItems lists all items for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.ListItems
 */
export const listItems = CortadoService.method.listItems;

/**
 * CreateItem creates a new item
 *
 * @generated from rpc cortado.v1.CortadoService.CreateItem
 */
export const createItem = CortadoService.method.createItem;

/**
 * GetItem retrieves an item by ID
 *
 * @generated from rpc cortado.v1.CortadoService.GetItem
 */
export const getItem = CortadoService.method.getItem;

/**
 * UpdateItem updates an item
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateItem
 */
export const updateItem = CortadoService.method.updateItem;

/**
 * DeleteItem deletes an item
 *
 * @generated from rpc cortado.v1.CortadoService.DeleteItem
 */
export const deleteItem = CortadoService.method.deleteItem;

/**
 * ReorderFormItems reorders the display order of items on the inquiry form
 *
 * @generated from rpc cortado.v1.CortadoService.ReorderFormItems
 */
export const reorderFormItems = CortadoService.method.reorderFormItems;

/**
 * GetTransportationItem gets the organization's mileage configuration.
 *
 * @generated from rpc cortado.v1.CortadoService.GetTransportationItem
 */
export const getTransportationItem = CortadoService.method.getTransportationItem;

/**
 * UpsertTransportationItem creates or updates the organization's mileage configuration.
 *
 * @generated from rpc cortado.v1.CortadoService.UpsertTransportationItem
 */
export const upsertTransportationItem = CortadoService.method.upsertTransportationItem;

/**
 * UploadItemImage adds a gallery image to a catalog item (JPEG/PNG/WebP, <= 10 MB, max 10 per item)
 *
 * @generated from rpc cortado.v1.CortadoService.UploadItemImage
 */
export const uploadItemImage = CortadoService.method.uploadItemImage;

/**
 * ListItemImages lists a catalog item's gallery images ordered by sort_order
 *
 * @generated from rpc cortado.v1.CortadoService.ListItemImages
 */
export const listItemImages = CortadoService.method.listItemImages;

/**
 * UpdateItemImage updates an image's alt text and/or marks it as the cover image
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateItemImage
 */
export const updateItemImage = CortadoService.method.updateItemImage;

/**
 * ReorderItemImages sets the display order of a catalog item's images
 *
 * @generated from rpc cortado.v1.CortadoService.ReorderItemImages
 */
export const reorderItemImages = CortadoService.method.reorderItemImages;

/**
 * DeleteItemImage removes a gallery image and its stored file
 *
 * @generated from rpc cortado.v1.CortadoService.DeleteItemImage
 */
export const deleteItemImage = CortadoService.method.deleteItemImage;

/**
 * UploadOrganizationGalleryImage adds a photo to the organization's portal gallery (JPEG/PNG/WebP, <= 10 MB, max 30)
 *
 * @generated from rpc cortado.v1.CortadoService.UploadOrganizationGalleryImage
 */
export const uploadOrganizationGalleryImage = CortadoService.method.uploadOrganizationGalleryImage;

/**
 * ListOrganizationGalleryImages lists the organization's gallery photos ordered by sort_order
 *
 * @generated from rpc cortado.v1.CortadoService.ListOrganizationGalleryImages
 */
export const listOrganizationGalleryImages = CortadoService.method.listOrganizationGalleryImages;

/**
 * UpdateOrganizationGalleryImage updates a gallery photo's alt text
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateOrganizationGalleryImage
 */
export const updateOrganizationGalleryImage = CortadoService.method.updateOrganizationGalleryImage;

/**
 * ReorderOrganizationGalleryImages sets the display order of the organization's gallery photos
 *
 * @generated from rpc cortado.v1.CortadoService.ReorderOrganizationGalleryImages
 */
export const reorderOrganizationGalleryImages = CortadoService.method.reorderOrganizationGalleryImages;

/**
 * DeleteOrganizationGalleryImage removes a gallery photo and its stored file
 *
 * @generated from rpc cortado.v1.CortadoService.DeleteOrganizationGalleryImage
 */
export const deleteOrganizationGalleryImage = CortadoService.method.deleteOrganizationGalleryImage;

/**
 * CalculateTransportationMileage calculates driving mileage for selected event locations.
 *
 * @generated from rpc cortado.v1.CortadoService.CalculateTransportationMileage
 */
export const calculateTransportationMileage = CortadoService.method.calculateTransportationMileage;

/**
 * ListTaxRates lists all tax rates for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.ListTaxRates
 */
export const listTaxRates = CortadoService.method.listTaxRates;

/**
 * CreateTaxRate creates a new tax rate
 *
 * @generated from rpc cortado.v1.CortadoService.CreateTaxRate
 */
export const createTaxRate = CortadoService.method.createTaxRate;

/**
 * ArchiveTaxRate archives a tax rate (soft delete)
 *
 * @generated from rpc cortado.v1.CortadoService.ArchiveTaxRate
 */
export const archiveTaxRate = CortadoService.method.archiveTaxRate;

/**
 * UpdateTaxRate updates a tax rate
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateTaxRate
 */
export const updateTaxRate = CortadoService.method.updateTaxRate;

/**
 * ListDiscounts lists all discounts for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.ListDiscounts
 */
export const listDiscounts = CortadoService.method.listDiscounts;

/**
 * CreateDiscount creates a new discount
 *
 * @generated from rpc cortado.v1.CortadoService.CreateDiscount
 */
export const createDiscount = CortadoService.method.createDiscount;

/**
 * GetDiscount retrieves a discount by ID
 *
 * @generated from rpc cortado.v1.CortadoService.GetDiscount
 */
export const getDiscount = CortadoService.method.getDiscount;

/**
 * UpdateDiscount updates a discount
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateDiscount
 */
export const updateDiscount = CortadoService.method.updateDiscount;

/**
 * ListQuoteTemplates lists all quote templates for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.ListQuoteTemplates
 */
export const listQuoteTemplates = CortadoService.method.listQuoteTemplates;

/**
 * CreateQuoteTemplate creates a new quote template
 *
 * @generated from rpc cortado.v1.CortadoService.CreateQuoteTemplate
 */
export const createQuoteTemplate = CortadoService.method.createQuoteTemplate;

/**
 * GetQuoteTemplate retrieves a quote template by ID
 *
 * @generated from rpc cortado.v1.CortadoService.GetQuoteTemplate
 */
export const getQuoteTemplate = CortadoService.method.getQuoteTemplate;

/**
 * GetQuoteTemplateByEventType retrieves a quote template by event type for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.GetQuoteTemplateByEventType
 */
export const getQuoteTemplateByEventType = CortadoService.method.getQuoteTemplateByEventType;

/**
 * UpdateQuoteTemplate updates a quote template
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateQuoteTemplate
 */
export const updateQuoteTemplate = CortadoService.method.updateQuoteTemplate;

/**
 * DeleteQuoteTemplate deletes a quote template
 *
 * @generated from rpc cortado.v1.CortadoService.DeleteQuoteTemplate
 */
export const deleteQuoteTemplate = CortadoService.method.deleteQuoteTemplate;

/**
 * GetQuotePreFill returns pre-filled quote data based on inquiry and template configuration
 *
 * @generated from rpc cortado.v1.CortadoService.GetQuotePreFill
 */
export const getQuotePreFill = CortadoService.method.getQuotePreFill;

/**
 * ListQuotes lists quotes with comprehensive filtering support
 *
 * @generated from rpc cortado.v1.CortadoService.ListQuotes
 */
export const listQuotes = CortadoService.method.listQuotes;

/**
 * GetQuoteStats returns aggregate quote counts and totals for an organization,
 * grouped into the stat-card buckets used by the quotes list page. Replaces
 * fetching every quote client-side to compute stats.
 *
 * @generated from rpc cortado.v1.CortadoService.GetQuoteStats
 */
export const getQuoteStats = CortadoService.method.getQuoteStats;

/**
 * ListContactQuoteInteractions lists public quote token interactions for a contact
 *
 * @generated from rpc cortado.v1.CortadoService.ListContactQuoteInteractions
 */
export const listContactQuoteInteractions = CortadoService.method.listContactQuoteInteractions;

/**
 * ListPortalVisitorActivity lists recipient-intent and browser-attributed
 * portal opens for one supported organization resource.
 *
 * @generated from rpc cortado.v1.CortadoService.ListPortalVisitorActivity
 */
export const listPortalVisitorActivity = CortadoService.method.listPortalVisitorActivity;

/**
 * CreateQuote creates a new quote
 *
 * @generated from rpc cortado.v1.CortadoService.CreateQuote
 */
export const createQuote = CortadoService.method.createQuote;

/**
 * GetQuote retrieves a quote by ID with full enrichment
 *
 * @generated from rpc cortado.v1.CortadoService.GetQuote
 */
export const getQuote = CortadoService.method.getQuote;

/**
 * GetQuoteDetail is an aggregate endpoint returning the quote plus its
 * inquiry, contact, booking (when the inquiry converted), and the invoice
 * created from it (if any), in one round-trip, to eliminate the
 * quote-detail page request waterfall.
 *
 * @generated from rpc cortado.v1.CortadoService.GetQuoteDetail
 */
export const getQuoteDetail = CortadoService.method.getQuoteDetail;

/**
 * UpdateQuote updates a quote
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateQuote
 */
export const updateQuote = CortadoService.method.updateQuote;

/**
 * DeleteQuote deletes a quote
 *
 * @generated from rpc cortado.v1.CortadoService.DeleteQuote
 */
export const deleteQuote = CortadoService.method.deleteQuote;

/**
 * SendQuote sends a quote email to the customer and updates status to SENT
 *
 * @generated from rpc cortado.v1.CortadoService.SendQuote
 */
export const sendQuote = CortadoService.method.sendQuote;

/**
 * PreviewQuoteSendEmail renders the Quote Sent email for one quote with an
 * optional per-send override. Mints no portal token and writes no rows.
 *
 * @generated from rpc cortado.v1.CortadoService.PreviewQuoteSendEmail
 */
export const previewQuoteSendEmail = CortadoService.method.previewQuoteSendEmail;

/**
 * DuplicateQuote creates a copy of an existing quote with all its data
 *
 * @generated from rpc cortado.v1.CortadoService.DuplicateQuote
 */
export const duplicateQuote = CortadoService.method.duplicateQuote;

/**
 * ListQuoteItems lists all items for a quote
 *
 * @generated from rpc cortado.v1.CortadoService.ListQuoteItems
 */
export const listQuoteItems = CortadoService.method.listQuoteItems;

/**
 * CreateQuoteItem creates a new quote item
 *
 * @generated from rpc cortado.v1.CortadoService.CreateQuoteItem
 */
export const createQuoteItem = CortadoService.method.createQuoteItem;

/**
 * GetQuoteItem retrieves a quote item by ID
 *
 * @generated from rpc cortado.v1.CortadoService.GetQuoteItem
 */
export const getQuoteItem = CortadoService.method.getQuoteItem;

/**
 * UpdateQuoteItem updates a quote item
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateQuoteItem
 */
export const updateQuoteItem = CortadoService.method.updateQuoteItem;

/**
 * DeleteQuoteItem deletes a quote item
 *
 * @generated from rpc cortado.v1.CortadoService.DeleteQuoteItem
 */
export const deleteQuoteItem = CortadoService.method.deleteQuoteItem;

/**
 * GetQuoteLitesByIds retrieves lightweight quotes by an array of IDs
 *
 * @generated from rpc cortado.v1.CortadoService.GetQuoteLitesByIds
 */
export const getQuoteLitesByIds = CortadoService.method.getQuoteLitesByIds;

/**
 * GenerateQuotePdf returns a cached or newly rendered quote PDF.
 *
 * @generated from rpc cortado.v1.CortadoService.GenerateQuotePdf
 */
export const generateQuotePdf = CortadoService.method.generateQuotePdf;

/**
 * ListInvoices lists invoices with comprehensive filtering support
 *
 * @generated from rpc cortado.v1.CortadoService.ListInvoices
 */
export const listInvoices = CortadoService.method.listInvoices;

/**
 * GetInvoiceStats returns aggregate invoice counts and totals for an organization,
 * grouped into the stat-card buckets used by the invoices list page. Replaces
 * fetching every invoice client-side to compute stats.
 *
 * @generated from rpc cortado.v1.CortadoService.GetInvoiceStats
 */
export const getInvoiceStats = CortadoService.method.getInvoiceStats;

/**
 * CreateInvoice creates a new invoice (typically from an accepted quote)
 *
 * @generated from rpc cortado.v1.CortadoService.CreateInvoice
 */
export const createInvoice = CortadoService.method.createInvoice;

/**
 * GetInvoice retrieves an invoice by ID with full details
 *
 * @generated from rpc cortado.v1.CortadoService.GetInvoice
 */
export const getInvoice = CortadoService.method.getInvoice;

/**
 * GetInvoiceDetail is an aggregate endpoint returning the invoice plus its
 * contact and booking (when set), in one round-trip, to eliminate the
 * invoice-detail page request waterfall.
 *
 * @generated from rpc cortado.v1.CortadoService.GetInvoiceDetail
 */
export const getInvoiceDetail = CortadoService.method.getInvoiceDetail;

/**
 * UpdateInvoice updates an invoice (creates a new revision if not locked)
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateInvoice
 */
export const updateInvoice = CortadoService.method.updateInvoice;

/**
 * DeleteInvoice deletes an invoice
 *
 * @generated from rpc cortado.v1.CortadoService.DeleteInvoice
 */
export const deleteInvoice = CortadoService.method.deleteInvoice;

/**
 * GetInvoiceLitesByIds retrieves lightweight invoices by an array of IDs
 *
 * @generated from rpc cortado.v1.CortadoService.GetInvoiceLitesByIds
 */
export const getInvoiceLitesByIds = CortadoService.method.getInvoiceLitesByIds;

/**
 * GenerateInvoicePdf returns a cached or newly rendered invoice PDF.
 *
 * @generated from rpc cortado.v1.CortadoService.GenerateInvoicePdf
 */
export const generateInvoicePdf = CortadoService.method.generateInvoicePdf;

/**
 * GeneratePaymentReceiptPdf returns a cached or newly rendered receipt PDF
 * for a payment schedule that has at least one completed payment.
 *
 * @generated from rpc cortado.v1.CortadoService.GeneratePaymentReceiptPdf
 */
export const generatePaymentReceiptPdf = CortadoService.method.generatePaymentReceiptPdf;

/**
 * CreatePaymentSchedule creates a new payment schedule for an invoice
 *
 * @generated from rpc cortado.v1.CortadoService.CreatePaymentSchedule
 */
export const createPaymentSchedule = CortadoService.method.createPaymentSchedule;

/**
 * UpdatePaymentSchedule updates a payment schedule (only if invoice not locked)
 *
 * @generated from rpc cortado.v1.CortadoService.UpdatePaymentSchedule
 */
export const updatePaymentSchedule = CortadoService.method.updatePaymentSchedule;

/**
 * DeletePaymentSchedule deletes a payment schedule (only if invoice not locked)
 *
 * @generated from rpc cortado.v1.CortadoService.DeletePaymentSchedule
 */
export const deletePaymentSchedule = CortadoService.method.deletePaymentSchedule;

/**
 * ReplacePaymentSchedules atomically replaces every payment schedule on an
 * invoice. Blocked if the invoice is locked, any schedule has recorded
 * payments, or an open checkout session exists for the invoice.
 *
 * @generated from rpc cortado.v1.CortadoService.ReplacePaymentSchedules
 */
export const replacePaymentSchedules = CortadoService.method.replacePaymentSchedules;

/**
 * CreatePaymentIntent is a dead endpoint that always returns Unimplemented.
 * Use CreatePublicCheckoutSession (Stripe Embedded Checkout) instead.
 *
 * @generated from rpc cortado.v1.CortadoService.CreatePaymentIntent
 * @deprecated
 */
export const createPaymentIntent = CortadoService.method.createPaymentIntent;

/**
 * GetPaymentIntent is a dead endpoint that always returns Unimplemented.
 * Payment status is read via GetPublicCheckoutSessionStatus / ListStripePayments.
 *
 * @generated from rpc cortado.v1.CortadoService.GetPaymentIntent
 * @deprecated
 */
export const getPaymentIntent = CortadoService.method.getPaymentIntent;

/**
 * UpdatePaymentIntentFromWebhook updates a payment intent from Stripe webhook
 *
 * @generated from rpc cortado.v1.CortadoService.UpdatePaymentIntentFromWebhook
 */
export const updatePaymentIntentFromWebhook = CortadoService.method.updatePaymentIntentFromWebhook;

/**
 * ListStripePayments lists individual payment attempts/charges for a payment intent or invoice
 *
 * @generated from rpc cortado.v1.CortadoService.ListStripePayments
 */
export const listStripePayments = CortadoService.method.listStripePayments;

/**
 * GetStripePayment retrieves a single payment/charge by ID
 *
 * @generated from rpc cortado.v1.CortadoService.GetStripePayment
 */
export const getStripePayment = CortadoService.method.getStripePayment;

/**
 * RecordManualPayment records a payment made outside of Stripe (check, wire transfer, cash, ACH)
 *
 * @generated from rpc cortado.v1.CortadoService.RecordManualPayment
 */
export const recordManualPayment = CortadoService.method.recordManualPayment;

/**
 * RecordBatchManualPayments records multiple manual payments atomically (all succeed or all fail)
 *
 * @generated from rpc cortado.v1.CortadoService.RecordBatchManualPayments
 */
export const recordBatchManualPayments = CortadoService.method.recordBatchManualPayments;

/**
 * ProcessStripeRefund initiates a refund through Stripe for an existing payment
 *
 * @generated from rpc cortado.v1.CortadoService.ProcessStripeRefund
 */
export const processStripeRefund = CortadoService.method.processStripeRefund;

/**
 * VoidManualPayment voids a manual payment (admin correction)
 *
 * @generated from rpc cortado.v1.CortadoService.VoidManualPayment
 */
export const voidManualPayment = CortadoService.method.voidManualPayment;

/**
 * ListInvoicePayments lists all payments (Stripe + manual) for an invoice
 *
 * @generated from rpc cortado.v1.CortadoService.ListInvoicePayments
 */
export const listInvoicePayments = CortadoService.method.listInvoicePayments;

/**
 * ExportInvoicePayments exports payments for an invoice as CSV
 *
 * @generated from rpc cortado.v1.CortadoService.ExportInvoicePayments
 */
export const exportInvoicePayments = CortadoService.method.exportInvoicePayments;

/**
 * VoidInvoice cancels an invoice and releases payment schedules
 *
 * @generated from rpc cortado.v1.CortadoService.VoidInvoice
 */
export const voidInvoice = CortadoService.method.voidInvoice;

/**
 * MarkInvoiceAsPaid creates a manual payment for the full remaining balance
 *
 * @generated from rpc cortado.v1.CortadoService.MarkInvoiceAsPaid
 */
export const markInvoiceAsPaid = CortadoService.method.markInvoiceAsPaid;

/**
 * SendInvoice sends an invoice email to the customer and updates status to SENT
 * For already-sent invoices, resends the email without changing status
 *
 * @generated from rpc cortado.v1.CortadoService.SendInvoice
 */
export const sendInvoice = CortadoService.method.sendInvoice;

/**
 * SendPaymentReminder sends a payment reminder email to the customer
 *
 * @generated from rpc cortado.v1.CortadoService.SendPaymentReminder
 */
export const sendPaymentReminder = CortadoService.method.sendPaymentReminder;

/**
 * ListDisputes lists Stripe disputes (chargebacks) for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.ListDisputes
 */
export const listDisputes = CortadoService.method.listDisputes;

/**
 * ListNotes lists notes with optional filters
 *
 * @generated from rpc cortado.v1.CortadoService.ListNotes
 */
export const listNotes = CortadoService.method.listNotes;

/**
 * CreateNote creates a new note
 *
 * @generated from rpc cortado.v1.CortadoService.CreateNote
 */
export const createNote = CortadoService.method.createNote;

/**
 * GetNote retrieves a note by ID
 *
 * @generated from rpc cortado.v1.CortadoService.GetNote
 */
export const getNote = CortadoService.method.getNote;

/**
 * UpdateNote updates a note
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateNote
 */
export const updateNote = CortadoService.method.updateNote;

/**
 * DeleteNote deletes a note
 *
 * @generated from rpc cortado.v1.CortadoService.DeleteNote
 */
export const deleteNote = CortadoService.method.deleteNote;

/**
 * CreateTask creates a new task
 *
 * @generated from rpc cortado.v1.CortadoService.CreateTask
 */
export const createTask = CortadoService.method.createTask;

/**
 * GetTask retrieves a task by ID
 *
 * @generated from rpc cortado.v1.CortadoService.GetTask
 */
export const getTask = CortadoService.method.getTask;

/**
 * UpdateTask updates a task
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateTask
 */
export const updateTask = CortadoService.method.updateTask;

/**
 * DeleteTask deletes a task
 *
 * @generated from rpc cortado.v1.CortadoService.DeleteTask
 */
export const deleteTask = CortadoService.method.deleteTask;

/**
 * ListAttachments lists attachments with optional filters
 *
 * @generated from rpc cortado.v1.CortadoService.ListAttachments
 */
export const listAttachments = CortadoService.method.listAttachments;

/**
 * CreateAttachment uploads a new attachment
 *
 * @generated from rpc cortado.v1.CortadoService.CreateAttachment
 */
export const createAttachment = CortadoService.method.createAttachment;

/**
 * GetAttachment retrieves an attachment by ID
 *
 * @generated from rpc cortado.v1.CortadoService.GetAttachment
 */
export const getAttachment = CortadoService.method.getAttachment;

/**
 * UpdateAttachment updates an attachment (filename only)
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateAttachment
 */
export const updateAttachment = CortadoService.method.updateAttachment;

/**
 * DeleteAttachment deletes an attachment
 *
 * @generated from rpc cortado.v1.CortadoService.DeleteAttachment
 */
export const deleteAttachment = CortadoService.method.deleteAttachment;

/**
 * ListAttachmentFolders lists attachment library folders for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.ListAttachmentFolders
 */
export const listAttachmentFolders = CortadoService.method.listAttachmentFolders;

/**
 * CreateAttachmentFolder creates a new attachment library folder
 *
 * @generated from rpc cortado.v1.CortadoService.CreateAttachmentFolder
 */
export const createAttachmentFolder = CortadoService.method.createAttachmentFolder;

/**
 * RenameAttachmentFolder renames an attachment library folder
 *
 * @generated from rpc cortado.v1.CortadoService.RenameAttachmentFolder
 */
export const renameAttachmentFolder = CortadoService.method.renameAttachmentFolder;

/**
 * MoveAttachmentFolder moves an attachment library folder under a new parent
 *
 * @generated from rpc cortado.v1.CortadoService.MoveAttachmentFolder
 */
export const moveAttachmentFolder = CortadoService.method.moveAttachmentFolder;

/**
 * DeleteAttachmentFolder deletes an attachment library folder
 *
 * @generated from rpc cortado.v1.CortadoService.DeleteAttachmentFolder
 */
export const deleteAttachmentFolder = CortadoService.method.deleteAttachmentFolder;

/**
 * ListFeedback lists all feedback for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.ListFeedback
 */
export const listFeedback = CortadoService.method.listFeedback;

/**
 * CreateFeedback creates a new feedback item
 *
 * @generated from rpc cortado.v1.CortadoService.CreateFeedback
 */
export const createFeedback = CortadoService.method.createFeedback;

/**
 * UpdateFeedback updates a feedback item (only creator can update content)
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateFeedback
 */
export const updateFeedback = CortadoService.method.updateFeedback;

/**
 * DeleteFeedback deletes a feedback item (only creator can delete)
 *
 * @generated from rpc cortado.v1.CortadoService.DeleteFeedback
 */
export const deleteFeedback = CortadoService.method.deleteFeedback;

/**
 * UpvoteFeedback adds the current user's upvote to a feedback item
 *
 * @generated from rpc cortado.v1.CortadoService.UpvoteFeedback
 */
export const upvoteFeedback = CortadoService.method.upvoteFeedback;

/**
 * RemoveUpvote removes the current user's upvote from a feedback item
 *
 * @generated from rpc cortado.v1.CortadoService.RemoveUpvote
 */
export const removeUpvote = CortadoService.method.removeUpvote;

/**
 * ListEmailTemplates lists all email templates for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.ListEmailTemplates
 */
export const listEmailTemplates = CortadoService.method.listEmailTemplates;

/**
 * CreateEmailTemplate creates a new email template
 *
 * @generated from rpc cortado.v1.CortadoService.CreateEmailTemplate
 */
export const createEmailTemplate = CortadoService.method.createEmailTemplate;

/**
 * GetEmailTemplate retrieves an email template by ID
 *
 * @generated from rpc cortado.v1.CortadoService.GetEmailTemplate
 */
export const getEmailTemplate = CortadoService.method.getEmailTemplate;

/**
 * RenderEmailTemplate renders an email template with entity context
 *
 * @generated from rpc cortado.v1.CortadoService.RenderEmailTemplate
 */
export const renderEmailTemplate = CortadoService.method.renderEmailTemplate;

/**
 * UpdateEmailTemplate updates an email template
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateEmailTemplate
 */
export const updateEmailTemplate = CortadoService.method.updateEmailTemplate;

/**
 * DeleteEmailTemplate deletes an email template
 *
 * @generated from rpc cortado.v1.CortadoService.DeleteEmailTemplate
 */
export const deleteEmailTemplate = CortadoService.method.deleteEmailTemplate;

/**
 * GetEmailTemplateCategories returns available template categories
 *
 * @generated from rpc cortado.v1.CortadoService.GetEmailTemplateCategories
 */
export const getEmailTemplateCategories = CortadoService.method.getEmailTemplateCategories;

/**
 * GetGmailAuthURL returns the OAuth URL for connecting Gmail
 *
 * @generated from rpc cortado.v1.CortadoService.GetGmailAuthURL
 */
export const getGmailAuthURL = CortadoService.method.getGmailAuthURL;

/**
 * IsGmailConnected checks if Gmail is connected and returns accounts
 *
 * @generated from rpc cortado.v1.CortadoService.IsGmailConnected
 */
export const isGmailConnected = CortadoService.method.isGmailConnected;

/**
 * RecheckGmailAccountHealth probes one Gmail account and persists its current health
 *
 * @generated from rpc cortado.v1.CortadoService.RecheckGmailAccountHealth
 */
export const recheckGmailAccountHealth = CortadoService.method.recheckGmailAccountHealth;

/**
 * UpdateGmailAccount updates a Gmail account (e.g., set as default)
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateGmailAccount
 */
export const updateGmailAccount = CortadoService.method.updateGmailAccount;

/**
 * DeleteGmailAccount disconnects a Gmail account
 *
 * @generated from rpc cortado.v1.CortadoService.DeleteGmailAccount
 */
export const deleteGmailAccount = CortadoService.method.deleteGmailAccount;

/**
 * CheckEventsCalendarExists checks if the "Events" calendar exists in Google Calendar
 *
 * @generated from rpc cortado.v1.CortadoService.CheckEventsCalendarExists
 */
export const checkEventsCalendarExists = CortadoService.method.checkEventsCalendarExists;

/**
 * ListGoogleCalendars lists all calendars in the connected Google accounts
 *
 * @generated from rpc cortado.v1.CortadoService.ListGoogleCalendars
 */
export const listGoogleCalendars = CortadoService.method.listGoogleCalendars;

/**
 * SetGoogleCalendar sets the calendar to use for event syncing
 *
 * @generated from rpc cortado.v1.CortadoService.SetGoogleCalendar
 */
export const setGoogleCalendar = CortadoService.method.setGoogleCalendar;

/**
 * PreviewCalendarDescription renders a (possibly unsaved) description
 * template against a real or synthetic event, without persisting anything
 *
 * @generated from rpc cortado.v1.CortadoService.PreviewCalendarDescription
 */
export const previewCalendarDescription = CortadoService.method.previewCalendarDescription;

/**
 * ApplyCalendarDescriptionTemplate reports (or, unless dry_run, triggers a
 * resync for) events whose Google Calendar description the org's stored
 * template would affect
 *
 * @generated from rpc cortado.v1.CortadoService.ApplyCalendarDescriptionTemplate
 */
export const applyCalendarDescriptionTemplate = CortadoService.method.applyCalendarDescriptionTemplate;

/**
 * GetStripeConnectionStatus checks if Stripe is connected and returns account details
 *
 * @generated from rpc cortado.v1.CortadoService.GetStripeConnectionStatus
 */
export const getStripeConnectionStatus = CortadoService.method.getStripeConnectionStatus;

/**
 * GetStripeAccountLinkURL creates account link URL for Stripe onboarding
 *
 * @generated from rpc cortado.v1.CortadoService.GetStripeAccountLinkURL
 */
export const getStripeAccountLinkURL = CortadoService.method.getStripeAccountLinkURL;

/**
 * DisconnectStripeAccount removes Stripe connection from organization
 *
 * @generated from rpc cortado.v1.CortadoService.DisconnectStripeAccount
 */
export const disconnectStripeAccount = CortadoService.method.disconnectStripeAccount;

/**
 * ListFailedWebhooks retrieves failed Stripe webhooks for potential replay.
 * If organization_id is provided, filters by org (org admin). Otherwise returns all (global admin).
 *
 * @generated from rpc cortado.v1.CortadoService.ListFailedWebhooks
 */
export const listFailedWebhooks = CortadoService.method.listFailedWebhooks;

/**
 * ListStaleWebhooks retrieves pending webhooks that appear stuck.
 * If organization_id is provided, filters by org (org admin). Otherwise returns all (global admin).
 *
 * @generated from rpc cortado.v1.CortadoService.ListStaleWebhooks
 */
export const listStaleWebhooks = CortadoService.method.listStaleWebhooks;

/**
 * ListWebhooks retrieves all webhooks for an organization (org admin)
 *
 * @generated from rpc cortado.v1.CortadoService.ListWebhooks
 */
export const listWebhooks = CortadoService.method.listWebhooks;

/**
 * ReplayWebhook replays a single webhook by event ID.
 * If organization_id is provided, verifies webhook belongs to org (org admin). Otherwise requires global admin.
 *
 * @generated from rpc cortado.v1.CortadoService.ReplayWebhook
 */
export const replayWebhook = CortadoService.method.replayWebhook;

/**
 * ReplayFailedWebhooks replays all failed webhooks up to a limit.
 * If organization_id is provided, only replays org's webhooks (org admin). Otherwise replays all (global admin).
 *
 * @generated from rpc cortado.v1.CortadoService.ReplayFailedWebhooks
 */
export const replayFailedWebhooks = CortadoService.method.replayFailedWebhooks;

/**
 * ReplayStaleWebhooks replays all stale pending webhooks.
 * If organization_id is provided, only replays org's webhooks (org admin). Otherwise replays all (global admin).
 *
 * @generated from rpc cortado.v1.CortadoService.ReplayStaleWebhooks
 */
export const replayStaleWebhooks = CortadoService.method.replayStaleWebhooks;

/**
 * GetOrganizationSubscription retrieves the subscription status for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.GetOrganizationSubscription
 */
export const getOrganizationSubscription = CortadoService.method.getOrganizationSubscription;

/**
 * GetPaymentHistory retrieves payment history for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.GetPaymentHistory
 */
export const getPaymentHistory = CortadoService.method.getPaymentHistory;

/**
 * CreateCheckoutSession creates a Stripe Checkout Session for subscribing.
 *
 * @generated from rpc cortado.v1.CortadoService.CreateCheckoutSession
 */
export const createCheckoutSession = CortadoService.method.createCheckoutSession;

/**
 * ReconcileCheckoutSession performs organization-scoped lost-webhook
 * recovery for a locally claimed Stripe Checkout Session.
 *
 * @generated from rpc cortado.v1.CortadoService.ReconcileCheckoutSession
 */
export const reconcileCheckoutSession = CortadoService.method.reconcileCheckoutSession;

/**
 * GetCustomerPortalURL returns the Stripe customer portal URL for managing a subscription.
 *
 * @generated from rpc cortado.v1.CortadoService.GetCustomerPortalURL
 */
export const getCustomerPortalURL = CortadoService.method.getCustomerPortalURL;

/**
 * GetSubscriptionProduct returns the eligible subscription product for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.GetSubscriptionProduct
 */
export const getSubscriptionProduct = CortadoService.method.getSubscriptionProduct;

/**
 * GetOrganizationBillingState retrieves the org billing/access state.
 *
 * @generated from rpc cortado.v1.CortadoService.GetOrganizationBillingState
 */
export const getOrganizationBillingState = CortadoService.method.getOrganizationBillingState;

/**
 * ListPlanOptions lists the purchasable plan+interval combinations for an organization.
 *
 * @generated from rpc cortado.v1.CortadoService.ListPlanOptions
 */
export const listPlanOptions = CortadoService.method.listPlanOptions;

/**
 * PreviewPlanChange previews the effect of a plan/interval change before committing it.
 *
 * @generated from rpc cortado.v1.CortadoService.PreviewPlanChange
 */
export const previewPlanChange = CortadoService.method.previewPlanChange;

/**
 * ChangeSubscriptionPlan changes an organization's plan and/or billing interval.
 *
 * @generated from rpc cortado.v1.CortadoService.ChangeSubscriptionPlan
 */
export const changeSubscriptionPlan = CortadoService.method.changeSubscriptionPlan;

/**
 * CancelSubscription schedules cancellation at the end of the current paid period.
 *
 * @generated from rpc cortado.v1.CortadoService.CancelSubscription
 */
export const cancelSubscription = CortadoService.method.cancelSubscription;

/**
 * ResumeSubscription reverses a scheduled cancellation before the paid term expires.
 *
 * @generated from rpc cortado.v1.CortadoService.ResumeSubscription
 */
export const resumeSubscription = CortadoService.method.resumeSubscription;

/**
 * GetSeatUsage returns an organization's seat usage and billing breakdown.
 *
 * @generated from rpc cortado.v1.CortadoService.GetSeatUsage
 */
export const getSeatUsage = CortadoService.method.getSeatUsage;

/**
 * GetNotificationDigest returns the organization's digest settings, timezone and recent sends.
 *
 * @generated from rpc cortado.v1.CortadoService.GetNotificationDigest
 */
export const getNotificationDigest = CortadoService.method.getNotificationDigest;

/**
 * UpdateNotificationDigest validates and saves the organization's digest settings.
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateNotificationDigest
 */
export const updateNotificationDigest = CortadoService.method.updateNotificationDigest;

/**
 * SendTestNotificationDigest sends the digest to the calling user now.
 *
 * @generated from rpc cortado.v1.CortadoService.SendTestNotificationDigest
 */
export const sendTestNotificationDigest = CortadoService.method.sendTestNotificationDigest;

/**
 * ListInAppNotifications retrieves in-app notifications for the current user
 *
 * @generated from rpc cortado.v1.CortadoService.ListInAppNotifications
 */
export const listInAppNotifications = CortadoService.method.listInAppNotifications;

/**
 * MarkNotificationsRead marks one or more notifications as read
 *
 * @generated from rpc cortado.v1.CortadoService.MarkNotificationsRead
 */
export const markNotificationsRead = CortadoService.method.markNotificationsRead;

/**
 * ArchiveNotifications archives one or more notifications
 *
 * @generated from rpc cortado.v1.CortadoService.ArchiveNotifications
 */
export const archiveNotifications = CortadoService.method.archiveNotifications;

/**
 * GetUnreadNotificationCount returns the count of unread notifications for the current user
 *
 * @generated from rpc cortado.v1.CortadoService.GetUnreadNotificationCount
 */
export const getUnreadNotificationCount = CortadoService.method.getUnreadNotificationCount;

/**
 * ListMyNotificationSettings returns the caller's own instant/off choice
 * for each notification type a user can set (mail notifications, CPRO-792)
 *
 * @generated from rpc cortado.v1.CortadoService.ListMyNotificationSettings
 */
export const listMyNotificationSettings = CortadoService.method.listMyNotificationSettings;

/**
 * UpdateMyNotificationSetting sets the caller's own choice for one type
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateMyNotificationSetting
 */
export const updateMyNotificationSetting = CortadoService.method.updateMyNotificationSetting;

/**
 * GetRealtimeQueries seals the org-scoped Neon Realtime live queries the
 * caller may subscribe to (new leads, accepted quotes, payments).
 *
 * @generated from rpc cortado.v1.CortadoService.GetRealtimeQueries
 */
export const getRealtimeQueries = CortadoService.method.getRealtimeQueries;

/**
 * ListPublicDomains retrieves custom public domains for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.ListPublicDomains
 */
export const listPublicDomains = CortadoService.method.listPublicDomains;

/**
 * AddPublicDomain registers a custom form or portal domain for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.AddPublicDomain
 */
export const addPublicDomain = CortadoService.method.addPublicDomain;

/**
 * VerifyPublicDomain refreshes DNS and provider verification status
 *
 * @generated from rpc cortado.v1.CortadoService.VerifyPublicDomain
 */
export const verifyPublicDomain = CortadoService.method.verifyPublicDomain;

/**
 * DeletePublicDomain removes a custom public domain from an organization
 *
 * @generated from rpc cortado.v1.CortadoService.DeletePublicDomain
 */
export const deletePublicDomain = CortadoService.method.deletePublicDomain;

/**
 * CreateWorkflowDefinition creates a new automation workflow definition
 *
 * @generated from rpc cortado.v1.CortadoService.CreateWorkflowDefinition
 */
export const createWorkflowDefinition = CortadoService.method.createWorkflowDefinition;

/**
 * ValidateWorkflowDefinition runs the same save-time validation
 * Create/UpdateWorkflowDefinition apply (trigger, conditions, graph,
 * stop_conditions) without persisting anything, returning field-keyed
 * issues so the builder can route errors to the right control instead of
 * matching on English error text.
 *
 * @generated from rpc cortado.v1.CortadoService.ValidateWorkflowDefinition
 */
export const validateWorkflowDefinition = CortadoService.method.validateWorkflowDefinition;

/**
 * GetWorkflowDefinition retrieves a workflow definition by ID
 *
 * @generated from rpc cortado.v1.CortadoService.GetWorkflowDefinition
 */
export const getWorkflowDefinition = CortadoService.method.getWorkflowDefinition;

/**
 * ListWorkflowDefinitions lists all workflow definitions for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.ListWorkflowDefinitions
 */
export const listWorkflowDefinitions = CortadoService.method.listWorkflowDefinitions;

/**
 * UpdateWorkflowDefinition updates an existing workflow definition
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateWorkflowDefinition
 */
export const updateWorkflowDefinition = CortadoService.method.updateWorkflowDefinition;

/**
 * DeleteWorkflowDefinition deletes a workflow definition
 *
 * @generated from rpc cortado.v1.CortadoService.DeleteWorkflowDefinition
 */
export const deleteWorkflowDefinition = CortadoService.method.deleteWorkflowDefinition;

/**
 * ListWorkflowExecutions lists executions for a workflow definition
 *
 * @generated from rpc cortado.v1.CortadoService.ListWorkflowExecutions
 */
export const listWorkflowExecutions = CortadoService.method.listWorkflowExecutions;

/**
 * GetWorkflowExecution retrieves one execution and its debug detail.
 *
 * @generated from rpc cortado.v1.CortadoService.GetWorkflowExecution
 */
export const getWorkflowExecution = CortadoService.method.getWorkflowExecution;

/**
 * GetWorkflowHealth returns a rolling-window count of failed workflow
 * executions for an organization, backing the "N automations failing" badge.
 *
 * @generated from rpc cortado.v1.CortadoService.GetWorkflowHealth
 */
export const getWorkflowHealth = CortadoService.method.getWorkflowHealth;

/**
 * RetryWorkflowExecution retries a failed workflow execution.
 *
 * @generated from rpc cortado.v1.CortadoService.RetryWorkflowExecution
 */
export const retryWorkflowExecution = CortadoService.method.retryWorkflowExecution;

/**
 * CancelWorkflowExecution stops an in-flight (Pending/Running) workflow
 * execution. It cancels the Temporal run; the execution workflow records the
 * terminal Cancelled status. Terminal executions are rejected (FailedPrecondition).
 *
 * @generated from rpc cortado.v1.CortadoService.CancelWorkflowExecution
 */
export const cancelWorkflowExecution = CortadoService.method.cancelWorkflowExecution;

/**
 * StartWorkflowExecution manually starts a workflow execution against a
 * specific entity, bypassing the definition's trigger conditions.
 *
 * @generated from rpc cortado.v1.CortadoService.StartWorkflowExecution
 */
export const startWorkflowExecution = CortadoService.method.startWorkflowExecution;

/**
 * CloneWorkflowDefinition creates a copy of an existing workflow definition
 *
 * @generated from rpc cortado.v1.CortadoService.CloneWorkflowDefinition
 */
export const cloneWorkflowDefinition = CortadoService.method.cloneWorkflowDefinition;

/**
 * EvaluateWorkflowConditions evaluates a condition tree against the org's
 * most-recent inquiry and returns a step-by-step trace for the condition editor.
 *
 * @generated from rpc cortado.v1.CortadoService.EvaluateWorkflowConditions
 */
export const evaluateWorkflowConditions = CortadoService.method.evaluateWorkflowConditions;

/**
 * GetWorkflowAuthoringSchema returns the server-owned authoring vocabulary
 * for the workflow builder: selectable trigger events (with publisher
 * wiring status), per-entity condition fields, template variables, and
 * recipient paths, plus the node types the builder may add.
 *
 * @generated from rpc cortado.v1.CortadoService.GetWorkflowAuthoringSchema
 */
export const getWorkflowAuthoringSchema = CortadoService.method.getWorkflowAuthoringSchema;

/**
 * ListWorkflowTemplates lists the code-defined workflow template registry
 * with per-org installed flags. Replaces per-org seeded stock rows.
 *
 * @generated from rpc cortado.v1.CortadoService.ListWorkflowTemplates
 */
export const listWorkflowTemplates = CortadoService.method.listWorkflowTemplates;

/**
 * InstallWorkflowTemplate instantiates a registry template into a regular,
 * org-owned, disabled workflow definition (creating any referenced tenant
 * email templates that are missing).
 *
 * @generated from rpc cortado.v1.CortadoService.InstallWorkflowTemplate
 */
export const installWorkflowTemplate = CortadoService.method.installWorkflowTemplate;

/**
 * ListWebhookEndpoints lists an organization's webhook endpoints.
 *
 * @generated from rpc cortado.v1.CortadoService.ListWebhookEndpoints
 */
export const listWebhookEndpoints = CortadoService.method.listWebhookEndpoints;

/**
 * CreateWebhookEndpoint registers a new endpoint, optionally with custom
 * outbound headers, and returns its one-time signing secret.
 *
 * @generated from rpc cortado.v1.CortadoService.CreateWebhookEndpoint
 */
export const createWebhookEndpoint = CortadoService.method.createWebhookEndpoint;

/**
 * UpdateWebhookEndpoint edits an endpoint's name, description, URL,
 * enabled flag, or custom outbound headers.
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateWebhookEndpoint
 */
export const updateWebhookEndpoint = CortadoService.method.updateWebhookEndpoint;

/**
 * DeleteWebhookEndpoint soft-deletes an endpoint. Rejected with
 * FailedPrecondition while any workflow definition references it.
 *
 * @generated from rpc cortado.v1.CortadoService.DeleteWebhookEndpoint
 */
export const deleteWebhookEndpoint = CortadoService.method.deleteWebhookEndpoint;

/**
 * RotateWebhookEndpointSecret replaces the signing secret and returns the
 * new one exactly once.
 *
 * @generated from rpc cortado.v1.CortadoService.RotateWebhookEndpointSecret
 */
export const rotateWebhookEndpointSecret = CortadoService.method.rotateWebhookEndpointSecret;

/**
 * SendTestWebhookEndpoint delivers a signed `webhook.test` envelope to the
 * endpoint synchronously and reports the response.
 *
 * @generated from rpc cortado.v1.CortadoService.SendTestWebhookEndpoint
 */
export const sendTestWebhookEndpoint = CortadoService.method.sendTestWebhookEndpoint;

/**
 * GetConnectInboxURL returns the hosted-auth URL that connects the caller's
 * own mailbox to the organization. Requires the EmailInbox entitlement.
 *
 * @generated from rpc cortado.v1.CortadoService.GetConnectInboxURL
 */
export const getConnectInboxURL = CortadoService.method.getConnectInboxURL;

/**
 * CompleteConnectInbox finishes a connect with the code and state the
 * hosted-auth callback forwarded to the browser. The state must belong to
 * the signed-in caller and the requested organization.
 *
 * @generated from rpc cortado.v1.CortadoService.CompleteConnectInbox
 */
export const completeConnectInbox = CortadoService.method.completeConnectInbox;

/**
 * ListConnectedMailboxes lists the organization's connected mailboxes,
 * disconnected ones included.
 *
 * @generated from rpc cortado.v1.CortadoService.ListConnectedMailboxes
 */
export const listConnectedMailboxes = CortadoService.method.listConnectedMailboxes;

/**
 * DisconnectMailbox disconnects a connected mailbox and revokes its Nylas
 * grant. Callers may disconnect their own mailbox; disconnecting a
 * teammate's needs Settings Manage (owners and admins). Captured threads
 * stay. When the org default disconnects, the oldest other active mailbox
 * takes over.
 *
 * @generated from rpc cortado.v1.CortadoService.DisconnectMailbox
 */
export const disconnectMailbox = CortadoService.method.disconnectMailbox;

/**
 * SetDefaultConnectedMailbox makes an active mailbox the organization's
 * default for automated mail. Owners and admins only.
 *
 * @generated from rpc cortado.v1.CortadoService.SetDefaultConnectedMailbox
 */
export const setDefaultConnectedMailbox = CortadoService.method.setDefaultConnectedMailbox;

/**
 * ListSendableMailboxes lists the organization's active connected
 * mailboxes for the "send from" picker, marking the ones the caller may
 * send as, and which one to preselect. Requires Manage Communications and
 * the EmailInbox entitlement.
 *
 * @generated from rpc cortado.v1.CortadoService.ListSendableMailboxes
 */
export const listSendableMailboxes = CortadoService.method.listSendableMailboxes;

/**
 * GetAutomatedEmailSender reports the address automated email (New
 * Inquiry, Quote Sent, invoices, reminders, workflow emails) sends from
 * right now: the org default connected mailbox (Connected inbox add-on
 * only), else the org default Gmail, else Cortado's own address.
 *
 * @generated from rpc cortado.v1.CortadoService.GetAutomatedEmailSender
 */
export const getAutomatedEmailSender = CortadoService.method.getAutomatedEmailSender;

/**
 * ListMailboxSendAccess lists the teammates a connected mailbox is shared
 * with, beyond its owner.
 *
 * @generated from rpc cortado.v1.CortadoService.ListMailboxSendAccess
 */
export const listMailboxSendAccess = CortadoService.method.listMailboxSendAccess;

/**
 * GrantMailboxSendAccess lets a teammate send as a connected mailbox. The
 * mailbox's owner may share it; sharing a teammate's needs Settings Manage
 * (owners and admins). Granting again changes nothing.
 *
 * @generated from rpc cortado.v1.CortadoService.GrantMailboxSendAccess
 */
export const grantMailboxSendAccess = CortadoService.method.grantMailboxSendAccess;

/**
 * RevokeMailboxSendAccess stops a teammate sending as a connected mailbox.
 * The same people who may grant may revoke.
 *
 * @generated from rpc cortado.v1.CortadoService.RevokeMailboxSendAccess
 */
export const revokeMailboxSendAccess = CortadoService.method.revokeMailboxSendAccess;

/**
 * ListMailboxesNeedingReconnect lists the organization's connected
 * mailboxes that lost their connection, for the app-wide banner. Any member
 * may call it; it returns nothing when the organization lacks the
 * EmailInbox entitlement.
 *
 * @generated from rpc cortado.v1.CortadoService.ListMailboxesNeedingReconnect
 */
export const listMailboxesNeedingReconnect = CortadoService.method.listMailboxesNeedingReconnect;

/**
 * ListEmailCaptureExclusions lists the organization's "Never capture"
 * entries: org-wide ones and every mailbox's own. Requires Manage
 * Communications and the EmailInbox entitlement.
 *
 * @generated from rpc cortado.v1.CortadoService.ListEmailCaptureExclusions
 */
export const listEmailCaptureExclusions = CortadoService.method.listEmailCaptureExclusions;

/**
 * AddEmailCaptureExclusion stops capturing mail to or from an address or
 * domain. An org-wide entry needs Settings Manage (owners and admins); a
 * mailbox entry needs the mailbox's owner or Settings Manage. Adding an
 * entry that exists returns it. With wipe_thread_id set it also deletes
 * that conversation's captured messages.
 *
 * @generated from rpc cortado.v1.CortadoService.AddEmailCaptureExclusion
 */
export const addEmailCaptureExclusion = CortadoService.method.addEmailCaptureExclusion;

/**
 * RemoveEmailCaptureExclusion deletes a "Never capture" entry. The same
 * people who may add it may remove it. Mail is captured again from then on;
 * nothing missed meanwhile is fetched.
 *
 * @generated from rpc cortado.v1.CortadoService.RemoveEmailCaptureExclusion
 */
export const removeEmailCaptureExclusion = CortadoService.method.removeEmailCaptureExclusion;

/**
 * ListEmailSenderSuggestions lists the organization's open "Not in
 * Cortado" suggestions: received mail from senders who are not contacts,
 * kept as metadata for 14 days. Also says whether the organization keeps
 * them. Requires Manage Communications and the EmailInbox entitlement.
 *
 * @generated from rpc cortado.v1.CortadoService.ListEmailSenderSuggestions
 */
export const listEmailSenderSuggestions = CortadoService.method.listEmailSenderSuggestions;

/**
 * ResolveEmailSenderSuggestion acts on a suggestion. LINK_CONTACT adds the
 * sender's address to contact_id (when it is not on it yet) and captures
 * the kept messages in full; it needs Manage Contacts too. IGNORE_SENDER
 * adds the sender to the never-capture list (org-wide for owners and
 * admins, else for the suggestion's mailbox when the caller owns it).
 * IGNORE_ONCE dismisses it.
 *
 * @generated from rpc cortado.v1.CortadoService.ResolveEmailSenderSuggestion
 */
export const resolveEmailSenderSuggestion = CortadoService.method.resolveEmailSenderSuggestion;

/**
 * SetEmailSenderSuggestionsEnabled turns "Suggest contacts from new
 * senders" on or off. Turning it off discards the open suggestions. Owners
 * and admins only.
 *
 * @generated from rpc cortado.v1.CortadoService.SetEmailSenderSuggestionsEnabled
 */
export const setEmailSenderSuggestionsEnabled = CortadoService.method.setEmailSenderSuggestionsEnabled;

/**
 * GetEmailCaptureSettings reads the organization's capture settings.
 * Requires Manage Communications and the EmailInbox entitlement.
 *
 * @generated from rpc cortado.v1.CortadoService.GetEmailCaptureSettings
 */
export const getEmailCaptureSettings = CortadoService.method.getEmailCaptureSettings;

/**
 * UpdateEmailCaptureSettings changes the organization's capture settings.
 * Also requires Settings Manage (owners and admins).
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateEmailCaptureSettings
 */
export const updateEmailCaptureSettings = CortadoService.method.updateEmailCaptureSettings;

/**
 * ListEmailSuppressions lists suppressed email addresses for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.ListEmailSuppressions
 */
export const listEmailSuppressions = CortadoService.method.listEmailSuppressions;

/**
 * CreateEmailSuppression manually adds an email address to the suppression list (reason is forced to MANUAL)
 *
 * @generated from rpc cortado.v1.CortadoService.CreateEmailSuppression
 */
export const createEmailSuppression = CortadoService.method.createEmailSuppression;

/**
 * DeleteEmailSuppression removes an email address from the suppression list
 *
 * @generated from rpc cortado.v1.CortadoService.DeleteEmailSuppression
 */
export const deleteEmailSuppression = CortadoService.method.deleteEmailSuppression;

/**
 * ListApiKeys lists the organization's external API keys (active and revoked)
 *
 * @generated from rpc cortado.v1.CortadoService.ListApiKeys
 */
export const listApiKeys = CortadoService.method.listApiKeys;

/**
 * CreateApiKey issues a new external API key; the secret is returned exactly once
 *
 * @generated from rpc cortado.v1.CortadoService.CreateApiKey
 */
export const createApiKey = CortadoService.method.createApiKey;

/**
 * RevokeApiKey permanently revokes an external API key
 *
 * @generated from rpc cortado.v1.CortadoService.RevokeApiKey
 */
export const revokeApiKey = CortadoService.method.revokeApiKey;

/**
 * SendInquiryEmail sends an email to a customer linked to an inquiry.
 *
 * TENANT-ONLY. This method must never appear in publicMethodAllowlist in
 * backend/internal/api/router/router.go: the portal is a customer-
 * authenticated surface and email threads may carry internal correspondence.
 *
 * @generated from rpc cortado.v1.CortadoService.SendInquiryEmail
 */
export const sendInquiryEmail = CortadoService.method.sendInquiryEmail;

/**
 * SendEmail sends an email to a customer linked to a supported parent entity
 *
 * @generated from rpc cortado.v1.CortadoService.SendEmail
 */
export const sendEmail = CortadoService.method.sendEmail;

/**
 * ListInquiryEmails retrieves the email thread for an inquiry.
 *
 * TENANT-ONLY. This method must never appear in publicMethodAllowlist in
 * backend/internal/api/router/router.go: the portal is a customer-
 * authenticated surface and email threads may carry internal correspondence.
 *
 * @generated from rpc cortado.v1.CortadoService.ListInquiryEmails
 */
export const listInquiryEmails = CortadoService.method.listInquiryEmails;

/**
 * ListEmails retrieves a flat email history for a parent entity (inquiry, contact, booking).
 * Superseded by ListEmailThreadsByEntity, which covers the
 * same mail now that every tenant send is filed under a linked conversation.
 * Kept for one release window for orgs without the Connected inbox add-on.
 *
 * @generated from rpc cortado.v1.CortadoService.ListEmails
 * @deprecated
 */
export const listEmails = CortadoService.method.listEmails;

/**
 * ListEmailThreads retrieves email threads for the inbox view
 *
 * @generated from rpc cortado.v1.CortadoService.ListEmailThreads
 */
export const listEmailThreads = CortadoService.method.listEmailThreads;

/**
 * ListEmailThreadsByEntity retrieves conversations linked to a CRM entity
 *
 * @generated from rpc cortado.v1.CortadoService.ListEmailThreadsByEntity
 */
export const listEmailThreadsByEntity = CortadoService.method.listEmailThreadsByEntity;

/**
 * MarkEmailThreadRead advances the current user's read position for a conversation
 *
 * @generated from rpc cortado.v1.CortadoService.MarkEmailThreadRead
 */
export const markEmailThreadRead = CortadoService.method.markEmailThreadRead;

/**
 * GetEmailThread retrieves a single email thread by ID with all messages
 *
 * @generated from rpc cortado.v1.CortadoService.GetEmailThread
 */
export const getEmailThread = CortadoService.method.getEmailThread;

/**
 * SaveDraft saves or updates one of the current user's drafts — a reply draft
 * on a thread, or a compose draft that has no thread yet
 *
 * @generated from rpc cortado.v1.CortadoService.SaveDraft
 */
export const saveDraft = CortadoService.method.saveDraft;

/**
 * DiscardDraft deletes one of the current user's drafts
 *
 * @generated from rpc cortado.v1.CortadoService.DiscardDraft
 */
export const discardDraft = CortadoService.method.discardDraft;

/**
 * ListEmailDrafts lists the current user's drafts so an interrupted compose
 * can be resumed from any session
 *
 * @generated from rpc cortado.v1.CortadoService.ListEmailDrafts
 */
export const listEmailDrafts = CortadoService.method.listEmailDrafts;

/**
 * RetryEmailBodyFetch retries fetching the body for an email
 *
 * @generated from rpc cortado.v1.CortadoService.RetryEmailBodyFetch
 */
export const retryEmailBodyFetch = CortadoService.method.retryEmailBodyFetch;

/**
 * GetEmailAttachmentDownloadUrl returns a short-lived URL that opens one
 * attachment on an email the caller can read. Files on captured mail stream
 * from the connected mailbox; Cortado never stores them.
 *
 * @generated from rpc cortado.v1.CortadoService.GetEmailAttachmentDownloadUrl
 */
export const getEmailAttachmentDownloadUrl = CortadoService.method.getEmailAttachmentDownloadUrl;

/**
 * RetryEmailSend restarts delivery for a queued or failed outbound email
 *
 * @generated from rpc cortado.v1.CortadoService.RetryEmailSend
 */
export const retryEmailSend = CortadoService.method.retryEmailSend;

/**
 * UpdateEmailThread updates an email thread's properties (status, assignment, links)
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateEmailThread
 */
export const updateEmailThread = CortadoService.method.updateEmailThread;

/**
 * LinkEmailThread attaches a conversation to any CRM entity via the
 * polymorphic email_thread_links table
 *
 * @generated from rpc cortado.v1.CortadoService.LinkEmailThread
 */
export const linkEmailThread = CortadoService.method.linkEmailThread;

/**
 * UnlinkEmailThread detaches a conversation from one CRM entity
 *
 * @generated from rpc cortado.v1.CortadoService.UnlinkEmailThread
 */
export const unlinkEmailThread = CortadoService.method.unlinkEmailThread;

/**
 * ListEmailThreadLinks lists every CRM entity a conversation is linked to
 *
 * @generated from rpc cortado.v1.CortadoService.ListEmailThreadLinks
 */
export const listEmailThreadLinks = CortadoService.method.listEmailThreadLinks;

/**
 * ListEmailThreadEntityCandidates lists the open leads and bookings of a
 * conversation's contact, for the "Which event is this about?" picker
 *
 * @generated from rpc cortado.v1.CortadoService.ListEmailThreadEntityCandidates
 */
export const listEmailThreadEntityCandidates = CortadoService.method.listEmailThreadEntityCandidates;

/**
 * ListEmailThreadAddressSuggestions lists addresses on a conversation that
 * a linked contact may also use: sent under that contact's name and on no
 * contact yet. Dismissed ones are left out for the caller.
 *
 * @generated from rpc cortado.v1.CortadoService.ListEmailThreadAddressSuggestions
 */
export const listEmailThreadAddressSuggestions = CortadoService.method.listEmailThreadAddressSuggestions;

/**
 * AcceptEmailThreadAddressSuggestion adds a suggested address to the
 * contact, with source capture. NotFound when the conversation no longer
 * suggests it; needs Manage Contacts on the contact.
 *
 * @generated from rpc cortado.v1.CortadoService.AcceptEmailThreadAddressSuggestion
 */
export const acceptEmailThreadAddressSuggestion = CortadoService.method.acceptEmailThreadAddressSuggestion;

/**
 * DismissEmailThreadAddressSuggestion hides a suggestion on a conversation
 * for the caller only.
 *
 * @generated from rpc cortado.v1.CortadoService.DismissEmailThreadAddressSuggestion
 */
export const dismissEmailThreadAddressSuggestion = CortadoService.method.dismissEmailThreadAddressSuggestion;

/**
 * ReplyToThread sends a reply within an existing email thread
 *
 * @generated from rpc cortado.v1.CortadoService.ReplyToThread
 */
export const replyToThread = CortadoService.method.replyToThread;

/**
 * ListSystemEmailTemplates returns all system email templates with their customization status
 *
 * @generated from rpc cortado.v1.CortadoService.ListSystemEmailTemplates
 */
export const listSystemEmailTemplates = CortadoService.method.listSystemEmailTemplates;

/**
 * GetSystemEmailTemplate returns a specific system email template with its current customizations
 *
 * @generated from rpc cortado.v1.CortadoService.GetSystemEmailTemplate
 */
export const getSystemEmailTemplate = CortadoService.method.getSystemEmailTemplate;

/**
 * UpdateSystemEmailTemplate updates the customizations for a system email template
 *
 * @generated from rpc cortado.v1.CortadoService.UpdateSystemEmailTemplate
 */
export const updateSystemEmailTemplate = CortadoService.method.updateSystemEmailTemplate;

/**
 * ResetSystemEmailTemplate removes all customizations and restores defaults
 *
 * @generated from rpc cortado.v1.CortadoService.ResetSystemEmailTemplate
 */
export const resetSystemEmailTemplate = CortadoService.method.resetSystemEmailTemplate;

/**
 * PreviewSystemEmailTemplate generates a preview with sample data
 *
 * @generated from rpc cortado.v1.CortadoService.PreviewSystemEmailTemplate
 */
export const previewSystemEmailTemplate = CortadoService.method.previewSystemEmailTemplate;

/**
 * GetReportingMetrics retrieves reporting metrics (close rate, leads count) for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.GetReportingMetrics
 */
export const getReportingMetrics = CortadoService.method.getReportingMetrics;

/**
 * GetSalesTaxReport retrieves a sales tax report grouped by tax rate for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.GetSalesTaxReport
 */
export const getSalesTaxReport = CortadoService.method.getSalesTaxReport;

/**
 * SubmitWaitlist adds an entry to the waitlist (public, no auth required)
 *
 * @generated from rpc cortado.v1.CortadoService.SubmitWaitlist
 */
export const submitWaitlist = CortadoService.method.submitWaitlist;

/**
 * GetPublicSignupEnabled returns whether public signup is enabled (public, no auth required)
 *
 * @generated from rpc cortado.v1.CortadoService.GetPublicSignupEnabled
 */
export const getPublicSignupEnabled = CortadoService.method.getPublicSignupEnabled;

/**
 * AdminCreateUser creates a new app user by email (Supabase + DB)
 *
 * @generated from rpc cortado.v1.CortadoService.AdminCreateUser
 */
export const adminCreateUser = CortadoService.method.adminCreateUser;

/**
 * AdminListUsers lists all app users in the system
 *
 * @generated from rpc cortado.v1.CortadoService.AdminListUsers
 */
export const adminListUsers = CortadoService.method.adminListUsers;

/**
 * @generated from rpc cortado.v1.CortadoService.AdminResendInvite
 */
export const adminResendInvite = CortadoService.method.adminResendInvite;

/**
 * AdminArchiveUser archives a user account so it can no longer log in
 *
 * @generated from rpc cortado.v1.CortadoService.AdminArchiveUser
 */
export const adminArchiveUser = CortadoService.method.adminArchiveUser;

/**
 * AdminUnarchiveUser unarchives a previously archived user account
 *
 * @generated from rpc cortado.v1.CortadoService.AdminUnarchiveUser
 */
export const adminUnarchiveUser = CortadoService.method.adminUnarchiveUser;

/**
 * @generated from rpc cortado.v1.CortadoService.AdminListOrganizations
 */
export const adminListOrganizations = CortadoService.method.adminListOrganizations;

/**
 * @generated from rpc cortado.v1.CortadoService.AdminGetOrganizationFeatures
 */
export const adminGetOrganizationFeatures = CortadoService.method.adminGetOrganizationFeatures;

/**
 * @generated from rpc cortado.v1.CortadoService.AdminEnableFeature
 */
export const adminEnableFeature = CortadoService.method.adminEnableFeature;

/**
 * @generated from rpc cortado.v1.CortadoService.AdminDisableFeature
 */
export const adminDisableFeature = CortadoService.method.adminDisableFeature;

/**
 * @generated from rpc cortado.v1.CortadoService.AdminDisableFeatureForAllOrgs
 */
export const adminDisableFeatureForAllOrgs = CortadoService.method.adminDisableFeatureForAllOrgs;

/**
 * @generated from rpc cortado.v1.CortadoService.AdminListFeatureCatalog
 */
export const adminListFeatureCatalog = CortadoService.method.adminListFeatureCatalog;

/**
 * @generated from rpc cortado.v1.CortadoService.AdminGetOrganization
 */
export const adminGetOrganization = CortadoService.method.adminGetOrganization;

/**
 * @generated from rpc cortado.v1.CortadoService.AdminGetOrganizationStats
 */
export const adminGetOrganizationStats = CortadoService.method.adminGetOrganizationStats;

/**
 * @generated from rpc cortado.v1.CortadoService.AdminGetSystemStats
 */
export const adminGetSystemStats = CortadoService.method.adminGetSystemStats;

/**
 * @generated from rpc cortado.v1.CortadoService.AdminGetOrganizationLeaderboard
 */
export const adminGetOrganizationLeaderboard = CortadoService.method.adminGetOrganizationLeaderboard;

/**
 * AdminUpdateFeedbackStage updates the stage of a feedback item (admin only)
 *
 * @generated from rpc cortado.v1.CortadoService.AdminUpdateFeedbackStage
 */
export const adminUpdateFeedbackStage = CortadoService.method.adminUpdateFeedbackStage;

/**
 * GetOrganizationIntegration retrieves an integration for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.GetOrganizationIntegration
 */
export const getOrganizationIntegration = CortadoService.method.getOrganizationIntegration;

/**
 * UpsertOrganizationIntegration creates or updates an integration for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.UpsertOrganizationIntegration
 */
export const upsertOrganizationIntegration = CortadoService.method.upsertOrganizationIntegration;

/**
 * DisconnectOrganizationIntegration marks an integration as disconnected
 *
 * @generated from rpc cortado.v1.CortadoService.DisconnectOrganizationIntegration
 */
export const disconnectOrganizationIntegration = CortadoService.method.disconnectOrganizationIntegration;

/**
 * ListSlackChannels returns the available Slack channels for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.ListSlackChannels
 */
export const listSlackChannels = CortadoService.method.listSlackChannels;

/**
 * GetConnectedSlackChannels returns the Slack channel IDs connected for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.GetConnectedSlackChannels
 */
export const getConnectedSlackChannels = CortadoService.method.getConnectedSlackChannels;

/**
 * SetConnectedSlackChannels updates the Slack channel IDs connected for an organization
 *
 * @generated from rpc cortado.v1.CortadoService.SetConnectedSlackChannels
 */
export const setConnectedSlackChannels = CortadoService.method.setConnectedSlackChannels;
